import enLocale from 'element-ui/lib/locale/lang/en';

// prettier-ignore
export default {
    ...enLocale,
    // 基础
    add: 'Tambah',
    edit: 'Kemaskini',
    delete: 'Padam',
    cancel: 'Batal',
    batch_edit: 'Kemaskini Banyak',
    title: 'Judul',
    desc: 'Keterangan',
    path: 'Laluan',
    icon: 'Ikon',
    permission: 'Keizinan',
    login: 'Log Masuk',
    logout: 'Log Keluar',
    date: 'Tarikh',
    download: 'Muat Turun',
    submit: 'Hantar',
    reset: 'Tetapkan Semula',
    sort: 'Susun',
    sure: 'Ya',
    negate: 'Tidak',
    settings: 'Pengaturcaraan',
    component: 'Komponen',
    search: 'Cari',
    more: 'Lebih',
    retract: 'Penarik Balik',
    download_table: 'Muat Turun Tabel',
    confirm: 'Pastikan',
    role: 'Peranan',
    email: 'Emel',
    name: 'Nama',
    account: 'Akaun',
    all: 'Semua',
    type: 'Jenis',
    time: 'Masa',
    handle: 'Bendalir',
    password: 'Kata Laluan',
    tips: 'Tip',
    past: 'Versi Lama',
    cover: 'Cover',
    status: 'Status',
    // login模块
    module_login: {
        zhaonaxue_admin: 'Platform Pengurusan Zhaonaxue',
        title: 'Platform Pengurusan Sekolah',
        username: 'username',
        password: 'password'
    },

    // cofigure模块
    module_configure: {
        parent_menu: 'menu induk',
        navigation: 'navigasi',
        enable: 'aktifkan',
        absolute: 'alamat mutlak',
        url: 'url',
        placeholder_title: 'masukkan judul (tidak lebih dari 24 karakter)',
        placeholder_parent: 'menu induk',
        placeholder_desc: 'deskripsi (tidak lebih dari 100 karakter)',
        placeholder_path: 'masukkan jalur',
        placeholder_icon: 'isi nama ikon',
        placeholder_sort: 'urutkan (isi angka)',
        placeholder_permission: 'pilih izin',
        placeholder_url: 'masukkan url belakang',
        placeholder_component: 'masukkan nama komponen',
        warn_title_empty: 'judul tidak boleh kosong',
        warn_title_limit: 'hingga 24 karakter',
        warn_desc_empty: 'deskripsi tidak boleh kosong',
        warn_desc_limit: 'hingga 100 karakter',
        warn_path_empty: 'jalur tidak boleh kosong',
        warn_sort_mepty: 'urutkan tidak boleh kosong',
        warn_sort_limit: 'urutkan harus angka',
        warn_navigation_empty: 'pilih apakah ini menu navigasi atau tidak',
        warn_absolute_empty: 'pilih apakah ini alamat mutlak atau tidak',
        warn_url_empty: 'URL tidak boleh kosong',
        warn_component_empty: 'nama komponen tidak boleh kosong'
    },
    module_settings: {
        update: 'kemas kini maklumat',
        change_password: 'ubah kata laluan',
        new_password: 'Kata Laluan Baru',
        comfirm_password: 'Pastikan',
        origin_password: 'kata laluan asal'
    },
    module_usage: {
        all: 'semua',
        explain: 'jelaskan',
        guide: 'petunjuk',
        update: 'kemas kini',
        placeholder: 'masukkan nama modul, judul atau kata kunci',
        details: 'butiran'
    },
    // 跟tab有关
    home: 'Rumah',
    school_manager: 'Pengurus Sekolah',
    school: 'Sekolah',
    selectSchool: 'Pilih Sekolah',
    staff: 'Staf',
    parent: 'Ibu Bapa',
    student: 'Pelajar',
    class: 'Kelas',
    course: 'Kursus',
    subject: 'Subjek',
    user_manager: 'Pengurus Pengguna',
    daily_manager: 'Pengurus Harian',
    product_manager: 'Pengurus Produk',
    payment_manager: 'Pengurus Bayaran',
    service_manager: 'Pengurus Perkhidmatan',
    device_manager: 'Pengurus Peranti',
    configure_manager: 'Pengurus Konfigurasi',
    configure_routes: 'Konfigurasi Rute',
    configure_menu: 'Konfigurasi Menu',
    monitor_manager: 'Pengurus Pemantauan',
    lab: 'Laboratorium',
    consumption_system: 'Sistem Penggunaan',
    consumption_statistics: 'Statistik Penggunaan',
    consumption_billFlow: 'Butiran Kewangan',
    consumption_device: 'Peranti & Had',
    consumption_account: 'Pengurusan Akaun',
    consumption_user: 'Pengurus Pengguna',
    bug: 'Penyimpanan Bug',
    bug_test: 'Ujian Bug',
    bug_view: 'Lihat Bug',
    usage_desc: 'desc',
    usage_details: 'butiran',
    auth: 'pengguna & kebenaran',
    auth_permission: 'kebenaran',
    auth_role: 'peranan',
    product_operation: 'produksi',
    knowledge_payment: 'pengetahuan & bayar',
    live_room: 'ruang langsung',
    members: 'ahli',
    // 跟动作有关
    close_all: 'Tutup Semua',
    close_others: 'Tutup Lain-lain',

    // 跟tools_bar有关
    usage: 'Penggunaan',
    full_screen: 'Skrin Penuh',
    exit_screen: 'Keluar',
    change_role: 'Peranan',
    // home模块
    module_home: {
        help: 'Pusat Bantuan',
        prod: 'Produksi',
        pre: 'Pelancaran',
        dev: 'Pembangunan',
        update: 'kemas kini terkini',
        guide: 'panduan pemula',
        desc: 'ringkasan',
        common: 'biasa',
    },
    // 消费系统
    module_consume: {
        consume_statistics: 'Statistik Penggunaan',
        cash_statistics: 'Statistik Tunai',
        day_statistics: 'Statistik Hari Ini',
        week_statistics: 'Statistik Minggu Ini',
        month_statistics: 'Statistik Bulan Ini',
        consumption: 'Penggunaan',
        top_up: 'Top Up Tunai',
        yuan: 'yuan',
        statistics_way: 'Metod Statistik',
        date_statistics: 'Tarikh',
        time_statistics: 'Slot Waktu',
        merchant_statistics: 'Bisnes',
        device_statistics: 'Peranti',
        user_statistics: 'Pengguna',
        set_statistics_range: 'Atur Rentang Statistik',
        set_time_slot: 'Atur Slot Waktu',
        operator_statistics: 'Operator',
        setting_way: 'Metod Penetapan',
        business_set: 'Menurut Bisnes',
        device_set: 'Menurut Peranti',
        device_need_statistics: 'Memerlukan Statistik',
        merchant_need_statistics: 'Memerlukan Statistik',
        device_not_statistics: 'Tidak Memerlukan Statistik',
        merchant_not_statistics: 'Tidak Memerlukan Statistik',
        merchant_name: 'Nama Bisnes',
        device_name: 'Nama Peranti',
        morning: 'Petang',
        noon: 'Siang',
        afternoon: 'Petang',
        evening: 'Malam',
        day_recharge: 'Pendahuluan Hari Ini',
        week_recharge: 'Pendahuluan Minggu Ini',
        month_recharge: 'Pendahuluan Bulan Ini',
        recharge_amount: 'Jumlah Pendahuluan'
    },
    // 筛选项
    module_selectors: {
        all: 'Semua',
        allSchool: 'Semua Sekolah',
        to: 'Ke',
        beginning: 'Awal',
        ending: 'Akhir',
        daily_statistics: 'Statistik Harian',
        weekly_statistics: 'Statistik Mingguan',
        monthly_statistics: 'Statistik Bulanan',
        teacher: 'Guru',
        student: 'Pelajar',
        parents: 'Ibu Bapa',
        account_balance: 'Saldo Akaun',
        alipay_withholding: 'Withholding Alipay',
        regular_account: 'Akaun Biasa',
        allowance_account: 'Akaun Izin',
        default_merchat: 'Merchant Default',
        school: 'Sekolah',
        date: 'Tarikh',
        time: 'Waktu',
        time_unit: 'Unit Waktu',
        user_type: 'Jenis Pengguna',
        select_device: 'Pilih Peranti',
        class: 'Kelas',
        device: 'Peranti',
        merchant: 'Bisnes',
        consume_type: 'Gaya Penggunaan',
        account_type: 'Jenis Akaun',
        operator: 'Operator',
        fund_custody: 'Kawalan Dana',
        search_user: 'Cari Pengguna',
        search_input: 'Nama atau nombor kad',
        cash: 'Tunai',
        wechat: 'WeChat',
        alipay: 'AliPay',
        grade: 'Gred',
        rule: 'Peraturan',
        rule_name: 'Nama Peraturan',
        start_time: 'Masa Mula',
        end_time: 'Masa Akhir',
        identify_state: 'Status Pengenal Pasti',
        acquaintance_degree: 'Darjah Kenalan',
        duplicate_removal: 'Penghapusan Duplikat',
        studentID_sort: 'Urutan ID Pelajar',
        device_type: 'Jenis peranti',
    },
    // 表格
    module_table: {
        date: 'Tarikh',
        name: 'Nama Penuh',
        class: 'Kelas',
        user: 'Pengguna',
        // Sistem Penggunaan
        device: 'Peranti',
        merchant: 'Bisnes',
        consume_income_statistics: 'Statistik Pendapatan Penggunaan',
        consume_yuan: 'Penggunaan(Yuan)',
        consume_time: 'Penggunaan(Waktu)',
        refund_expend_statistics: 'Statistik Pengembalian Belanja',
        refund_yuan: 'Pengembalian(Yuan)',
        refunt_time: 'Pengembalian(Waktu)',
        consume_balance: 'Saldo Penggunaan(Yuan)',
        operation: 'Operasi',
        details: 'Butiran',
        cash_income_statistics: 'Statistik Pendapatan Tunai',
        cash_expend_statistics: 'Statistik Belanja Tunai',
        topUp_yuan: 'Top Up(Yuan)',
        topUp_time: 'Top Up(Waktu)',
        cash_withdrawal_yuan: 'Penarikan Tunai(Yuan)',
        cash_withdrawal_time: 'Penarikan Tunai(Waktu)',
        withdraw_yuan: 'Penarikan Kad(Yuan)',
        withdraw_time: 'Penarikan Kad(Waktu)',
        cash_expend_all: 'Statistik Belanja Tunai(Yuan)',
        cash_balance: 'Saldo Tunai(Yuan)',
        device_info: 'Info Peranti',
        location: 'Lokasi',
        business: 'Bisnes',
        user_info: 'Info Pengguna',
        card_num: 'Nombor Kad',
        morning_yuan: 'Petang(Yuan)',
        noon_yuan: 'Siang(Yuan)',
        afternoon_yuan: 'Petang(Yuan)',
        evening_yuan: 'Malam(Yuan)',
        total_yuan: 'Total Penggunaan(Yuan)',
        total_time: 'Total Penggunaan(Waktu)',
        weixin_income_statistics: 'Statistik Pendapatan WeChat'
    },
    // auth模块
    module_auth: {
        permission_placeholder: 'Silakan cari nama kebenaran',
        role_placeholder: 'Silakan cari nama peranan',
        authorize: 'bertimbang',
        configure: 'konfigurasikan',
        update: 'kemas kini',
        delete: 'hapus',
        add_permission: 'tambah kebenaran',
        add_role: 'tambah peranan',
        update_permission: 'kemas kini kebenaran',
        update_role: 'kemas kini peranan',
        filter_placeholder: 'Masukkan kata kunci untuk menyaring',
        permission_parent_name: 'ibu',
        role_parent_name: 'ibu',
        permission_name: 'kebenaran',
        role_name: 'peranan',
        placeholder: 'Silakan masukkan kandungan',
        delete_message: 'Apakah anda pasti ingin menghapusnya?',
        cancle_message: 'Batalkan penghapusan!'
    },
    module_knowledge_payment: {
        school: 'sekolah',
        agent: 'agen',
        all: 'semua',
        list: 'Senarai Sekolah',
        school_name: 'nama',
        school_number: 'nombor',
        placeholder: 'Silakan masukkan kata kunci',
        free: 'Tidak Dikenakan Caj',
        charge: 'Dikenakan Caj',
        create: 'studio langsung baru',
        update: 'kemas kini studio langsung',
        name: 'tajuk kursus',
        desc: 'pembentangan',
        coupon: 'pautan kupon',
        url: 'pautan kursus',
        cover: 'lapisan kursus',
        name_placeholder: 'Silakan masukkan nama kursus (tidak lebih daripada 30 perkata)',
        desc_placeholder: 'Silakan masukkan pembentangan kursus (tidak lebih daripada 30 perkata)',
        url_placeholder: 'Silakan masukkan pautan kursus',
        coupon_placeholder: 'Silakan masukkan pautan kupon',
        cover_message: 'Silakan muat naik lapisan',
        name_message: 'Silakan masukkan nama kursus.',
        desc_message: 'Silakan masukkan pembentangan kursus',
        url_message: 'Silakan masukkan pautan kursus',
        coupon_message: 'Silakan masukkan pautan kupon',
        name_message_max: 'Nama Kursus Tidak Boleh Lebih Daripada 30 Perkata',
        desc_message_max: 'Profil Kursus Tidak Boleh Lebih Daripada 30 Perkata',
        url_message_max: 'Pautan kursus tidak boleh melebihi 300 perkata',
        coupon_message_max: 'Pautan kupon tidak boleh melebihi 300 perkata'
    },
    '学校名称：': 'Nama Sekolah:',
    '人脸照片采集说明.': 'Penjelasan Pengumpulan Foto Muka.',
    '发布中.': 'Menerbitkan...',
    '截止时间': 'batas waktu',
    '发布时间': 'waktu penerbitan',
    '人脸识别闸门2代:70及其以上版本,低版本的请先升级': 'gerbang pengenalan wajah generasi kedua: versi 70 dan di atas, silakan tingkatkan jika versi lebih rendah',
    '附件': 'lampiran',
    '出错了': 'terjadi kesalahan',
    '删除中.': 'Dalam proses penghapusan.',
    '确定移除': 'Pastikan untuk hapus',
    '收费对象': 'Objek yang dikenakan bayaran',
    '取消时长:': 'Durasi pembatalan:',
    '对象范围': 'jangkauan objek',
    '生效时间: ': 'mula berkesan:',
    '恢复激活年限:': 'restores tempoh aktivasi:',
    '人脸录入完毕后,系统会自动录入该': 'setelah pengenalan wajah selesai, sistem akan secara automatik memasukkan itu',
    '进出设置:': 'penyetelan masuk keluar:',
    '考试科目:': 'subjek ujian:',
    '已录入:': 'sudah dimasukkan:',
    '科目名称': 'nama subjek',
    '选择范围': 'pilih kawasan',
    '收费说明': 'penjelasan tentang bayaran',
    '更新`:': 'kemas kini `',
    '校园缴费表格模板.': 'templat borang pembayaran kampus.',
    '一次识别阈值必须大于': 'nilai had pengenalan tunggal harus lebih besar daripada',
    '考试人数:': 'bilangan orang yang menjalani ujian:',
    '代理商名称': 'nama agen',
    '考试名称:': 'nama ujian:',
    '最小脸部': 'wajah minimum',
    '进出设置: ': 'tetapan masuk keluar: ',
    '剩余激活年限:': 'tahun aktivasi yang tinggal:',
    '校园卡号': 'nombor kad kampus',
    '二次识别活体阈值不能为': 'had kedua-dua pengenalan kehidupan tidak boleh menjadi',
    '人脸库同步期间，人脸识别功能不可用。你确定要同步': 'semasa sinkronisasi perpustakaan wajah, fungsi pengenalan wajah tidak boleh digunakan. Adakah anda pasti ingin menyinkronkan?',
    '通知内容': 'kandungan peringatan',
    '考试班级:': 'kelas ujian:',
    '生日': 'hari lahir',
    '选择文件': 'pilih fail',
    '批量录入速度:约每10分钟可录入60人': 'kecepatan pemindahan dalam jumlah besar: kira-kira setiap 10 minit boleh memasukkan 60 orang',
    '更新': 'Kemas kini',
    '激活费用:': 'Biaya aktivasi:',
    '学号': 'Nombor pelajar',
    '已识别（': 'Telah dikenali (',
    '等其他学校人脸录入完毕后,系统会自动录入该': 'Selepas sekolah lain menyelesaikan wajah, sistem akan secara otomatis memasukkan ini',
    '识别阈值': 'Nilai Pengenalan',
    '最小识别阈值不能为': 'Nilai Pengenalan Minimum Tidak Boleh',
    '未识别（': 'Tidak Dikenali (',
    '发布人': 'Penerbit',
    '激活时长:': 'Durasi Aktif:',
    '生效时间:': 'Tempoh Berkesan:',
    '通知标题': 'Judul Notifikasi',
    '性别': 'Jenis Kelamin',
    '分账商户': 'Penjual Bahagian',
    '科目': 'Subjek',
    '交费规则': 'Aturan Bayaran',
    '家长数': 'Nombor Ibu Bapa',
    '学生总数:': 'Jumlah Pelajar:',
    '已开启': 'Dialihkan',
    '二次识别阈值不能为': 'Nilai Pengenalan Kedua Tidak Boleh',
    '提交内容失败': 'Gagal Mengirim Kandungan',
    '亲属关系': 'Hubungan Keluarga',
    '服务错误,请重试': 'Kesalahan Perkhidmatan, Silakan Coba Lagi',
    '信息中心': 'Pusat Maklumat',
    '校务中心': 'Pusat Urusan Sekolah',
    '安全中心': 'Pusat Keselamatan',
    '财务中心': 'Pusat Kewangan',
    '设置中心': 'Pusat Tetapan',
    '运营中心': 'Pusat Operasi',
    '五育运用': 'Penerapan Lima Pendidikan',


    '菜单管理': 'Pengurusan menu',
    '照片名称': 'Nama foto',
    '完成': 'Selesai',
    '订餐人次': 'Bilangan orang yang memesan makanan',
    '用户管理': 'Pengurusan pengguna',
    '学校管理员' : 'Pengurus Sekolah',
    '学校职工' : 'Staf Sekolah',
    '考试成功！': 'Kejayaan peperiksaan!',
    '排序不能为空': 'Isih tidak boleh kosong',
    '按操作人员统计': 'Statistik mengikut pengendali',
    '人脸识别已开启': 'Pengecaman muka dihidupkan',
    '设备与限制': 'Peralatan dan had',
    '温馨提示': 'Petua yang baik',
    '请先输入分账商户列表的商户号': 'Sila masukkan nombor pedagang senarai pedagang sub-akaun dahulu',
    '暂无班级数据': 'Tiada data kelas lagi',
    '录入状态': 'Status kemasukan',
    '操作者': 'pengendali',
    '登录': 'Log masuk',
    '默认商户': 'Pedagang lalai',
    '按餐次统计': 'Statistik mengikut makanan',
    '父级菜单': 'Menu ibu bapa',
    '添加更多家长': 'Tambah lagi ibu bapa',
    '缴费管理': 'Pengurusan pembayaran',
    '交费状态': 'Status pembayaran',
    '是否开启收费': 'Sama ada untuk mendayakan pengecasan',
    '用户信息': 'Maklumat pengguna',
    '删除门禁': 'Padamkan kawalan akses',
    '孩子所属姓名': 'nama anak',
    '后台地址': 'Alamat hujung belakang',
    '选择年级': 'Pilih gred',
    '删除': 'padam',
    '授权管理': 'Pengurusan kebenaran',
    '按时就餐人次': 'Bilangan orang yang makan tepat pada masanya',
    '班级': 'kelas',
    '无数据': 'Tiada data',
    '充值统计': 'Statistik cas semula',
    '请先输入商户号': 'Sila masukkan nombor peniaga dahulu',
    '批量录入速': 'Kelajuan kemasukan kelompok',
    '重新下载': 'Muat turun semula',
    '收集': 'mengumpul',
    '导入失败，请修改后重新上传': 'Import gagal, sila ubah suai dan muat naik semula.',
    '下载人脸照片采集说明': 'Muat turun arahan untuk mengumpul foto muka',
    '学校管理': 'pengurusan sekolah',
    '科目名称：': 'nama subjek:',
    '批量导入历史': 'Sejarah import kelompok',
    '人脸识别闸门2代：104及其以上版本，低版本的请先升级': 'Gerbang pengecaman muka 2: versi 104 dan ke atas, sila tingkatkan dahulu jika anda mempunyai versi yang lebih rendah.',
    '请先输入分账商户列表的商户名称': 'Sila masukkan nama pedagang senarai pedagang sub-akaun dahulu',
    '识别时间': 'masa pengiktirafan',
    '确认提交后，系统将生成账单的支付信息，并修改账单的状态，是否继续执行': 'Selepas mengesahkan penyerahan, sistem akan menjana maklumat pembayaran bil dan mengubah suai status bil untuk menentukan sama ada untuk meneruskan pelaksanaan.',
    '校园缴费表格模板': 'Templat borang pembayaran kampus',
    '关联公众号：': 'Akaun awam berkaitan:',
    '批量录入说明': 'Arahan kemasukan kelompok',
    '不参与': 'Tidak mengambil bahagian',
    '当前账单已取消收费，无法进行催交': 'Bil semasa telah dibatalkan dan pembayaran tidak dapat disegerakan.',
    '上传完成': 'Muat naik selesai',
    '的操作': 'Operasi',
    '三次识别阈值': 'ambang pengecaman tiga kali ganda',
    '家长': 'ibu bapa',
    '分账状态': 'Status lejar',
    '上传人脸excel文件失败': 'Gagal memuat naik fail face excel',
    '的生效时段开始时间必选小于结束时间': 'Masa mula tempoh berkesan mestilah lebih kecil daripada masa tamat',
    '说明': 'menggambarkan',
    '商户单号': 'Nombor pesanan peniaga',
    '出错了：': 'Sesuatu telah berlaku:',
    '设置成功': 'Persediaan berjaya',
    '已识别（BD2）': 'Diiktiraf (BD2)',
    '1、照片格式要求': '1. Keperluan format foto',
    '退款支出统计': 'Statistik perbelanjaan bayaran balik',
    '服务状态（点击修改状态）': 'Status perkhidmatan (klik untuk mengubah suai status)',
    '历史记录': 'Sejarah',
    '校园缴费v1.2_后台_获取商户最大分账比例接口失败': 'Pembayaran kampus v1.2_backend_failed untuk mendapatkan antara muka nisbah pembahagian akaun maksimum pedagang',
    '交费状态`': 'Status pembayaran`',
    '全部分类': 'Semua kategori',
    '学籍状态': 'Status Pelajar',
    '确认密码': 'Sahkan Kata Laluan',
    '请输入课程简介（不超过30个字）': 'Sila masukkan pengenalan kursus (tidak lebih daripada 30 patah perkataan)',
    '更多': 'Lagi',
    '请输入手机号': 'Sila masukkan nombor telefon bimbit',
    '已识别（BD1）': 'Diiktiraf (BD1)',
    '详情页': 'Halaman butiran',
    '激活学校收费接口失败': 'Gagal mengaktifkan antara muka pengecasan sekolah',
    '请先点击此处': 'Sila klik di sini dahulu',
    '请输入二次识别活体阈值': 'Sila masukkan ambang untuk pengenalan menengah bagi subjek hidup',
    '初始化': 'permulaan',
    '常用功能': 'Fungsi yang biasa digunakan',
    '请输入课程名称（不超过30个字）': 'Sila masukkan nama kursus (tidak lebih daripada 30 aksara)',
    '新建直播间': 'Buat bilik siaran langsung baharu',
    '消费': 'Penggunaan',
    '组件': 'komponen',
    '请先选择发布人': 'Sila pilih penerbit dahulu',
    '已开启：': 'Sudah dihidupkan:',
    '班级管理': 'Pengurusan kelas',
    '图标': 'ikon',
    '学校id': 'id sekolah',
    '规则名称': 'Nama peraturan',
    '已批量配置成功': 'Berjaya dikonfigurasikan dalam kelompok',
    '延时时间': 'Masa kelewatan',
    '选择渠道': 'Pilih saluran',
    '请输入学生姓名': 'Sila masukkan nama pelajar',
    '现金收入统计': 'Statistik pendapatan tunai',
    '正在添加家长,请勿重复操作!': 'Menambah ibu bapa, tolong jangan ulangi operasi!',
    '邮箱': 'Mel',
    '新手引导': 'Panduan baru',
    '未录入': 'Tak masuk',
    '重新上传': 'Muat naik semula',
    '已过期': 'Tamat tempoh',
    '已删除': 'Dipadamkan',
    '获取规则详情': 'Dapatkan butiran peraturan',
    '确定': 'pasti',
    '当前号码存在以下订阅服务': 'Perkhidmatan langganan berikut wujud untuk nombor semasa',
    '催交成功，未交费的家长将收到推送提醒': 'Jika peringatan itu berjaya, ibu bapa yang belum membuat pembayaran akan menerima peringatan tolak.',
    '账单已截止，不可操作不参与': 'Bil telah tamat tempoh dan tidak boleh digunakan.',
    '选择日期时间': 'Pilih masa tarikh',
    '充值金额': 'Jumlah cas semula',
    '模板背景': 'latar belakang templat',
    '发布人：': 'Dihantar oleh:',
    '请输入识别阈值': 'Sila masukkan ambang pengecaman',
    '数据同步中，稍等片刻点击刷新查看同步情况': 'Data sedang disegerakkan, sila tunggu sebentar dan klik Muat Semula untuk melihat status penyegerakan.',
    '使用中': 'Sedang digunakan',
    '补助账户': 'akaun subsidi',
    '获取配置失败,请刷新重试': 'Gagal mendapatkan konfigurasi, sila muat semula dan cuba lagi',
    '金额': 'Jumlah',
    '请输入功能名称、标题、关键字': 'Sila masukkan nama fungsi, tajuk, kata kunci',
    '查看批量录入历史': 'Lihat sejarah kemasukan kelompok',
    '永久': 'kekal',
    '退出登录': 'Log keluar',
    '未分账': 'Akaun tidak berbelah bahagi',
    '请先选择代理商': 'Sila pilih ejen dahulu',
    '请选择亲属关系': 'Sila pilih persaudaraan',
    '孩子姓名': 'nama anak',
    '直播间': 'Bilik siaran langsung',
    '上传名单': 'Muat naik senarai',
    '请先输入通知标题': 'Sila masukkan tajuk pemberitahuan dahulu',
    '创建收款码失败': 'Gagal membuat kod pembayaran',
    '请假放行': 'Tinggalkan dan lepaskan',
    '套餐设置': 'Tetapan pakej',
    '登记信息：': 'Maklumat pendaftaran:',
    '正式运营': 'Operasi formal',
    '3、对于已录入照片的用户，重新录入的话，新照片将会覆盖旧照片。': '3. Bagi pengguna yang telah memasukkan foto, jika mereka memasukkan semula foto tersebut, foto baharu akan menimpa foto lama.',
    '请选择学生标识': 'Sila pilih ID pelajar',
    '就餐时间设置': 'Tetapan waktu makan',
    '发布成绩': 'Siarkan keputusan',
    '学校未开通微信商户，请联系运营人员开通': 'Pihak sekolah belum membuka peniaga WeChat, sila hubungi kakitangan operasi untuk mengaktifkannya.',
    '按周统计': 'Statistik mengikut minggu',
    '请选择适用设备': 'Sila pilih peranti yang berkenaan',
    '创建账单成功': 'Bil berjaya dibuat',
    '考试人': 'pemeriksa',
    '同步中': 'Menyegerakkan',
    '未选择': 'Tidak dipilih',
    '统计报表': 'Laporan statistik',
    '无需录入': 'Tiada kemasukan diperlukan',
    '元': 'Yuan',
    '退卡(元)': 'Bayaran balik kad (yuan)',
    '1、选择“用户类型”': '1. Pilih "Jenis Pengguna"',
    '用户与权限': 'Pengguna dan kebenaran',
    '请输入校园卡号': 'Sila masukkan nombor kad kampus anda',
    '确认开始批量录入': 'Sahkan untuk memulakan kemasukan kelompok',
    '系统': 'sistem',
    '分账状态：': 'Status akaun:',
    '请输入token': 'Sila masukkan token',
    '付费专区': 'paywall',
    '允许进出': 'dibenarkan masuk dan keluar',
    '这是': 'Ini adalah',
    '人脸识别闸门：93及其以上版本，低版本的请先升级': 'Gerbang pengecaman muka: versi 93 dan ke atas, sila tingkatkan dahulu untuk versi yang lebih rendah.',
    '排序（请填写数字）': 'Isih (sila isi nombor)',
    '上传图片失败': 'Gagal memuat naik imej',
    '请输入播报名称': 'Sila masukkan nama siaran',
    '孵化中': 'mengeram',
    '六': 'enam',
    '请选择用户类型': 'Sila pilih jenis pengguna',
    '抓拍图片': 'Tangkap gambar',
    '学校': 'Sekolah',
    '共': 'biasa',
    '未发布': 'Tidak diterbitkan',
    '处理删除': 'Mengendalikan pemadaman',
    '关': 'dekat',
    '女': 'perempuan',
    '晚上消费(元)': 'Penggunaan malam (yuan)',
    '选择用户类型': 'Pilih jenis pengguna',
    '不能为空': 'tidak boleh kosong',
    '线下支付': 'Pembayaran luar talian',
    '标题': 'tajuk',
    '请输入路径': 'Sila masukkan laluan',
    '个人设置': 'tetapan peribadi',
    '学生总': 'jumlah pelajar',
    '考试名称已超出限定的20个字数': 'Nama peperiksaan melebihi had 20 aksara',
    '首页': 'muka depan',
    '按设备统计': 'Statistik mengikut peranti',
    '详情': 'Butiran',
    '未设置': 'tidak ditetapkan',
    '无匹配数据': 'Tiada data yang sepadan',
    '鼠标移动到此处查看目前支持的设备和版本': 'Gerakkan tetikus anda ke sini untuk melihat peranti dan versi yang disokong pada masa ini',
    '查找不到设备？鼠标移到此处查看目前支持的设备和版本': 'Tidak menemui peranti itu? Gerakkan tetikus anda ke sini untuk melihat peranti dan versi yang disokong pada masa ini',
    '不生效日期': 'Tiada tarikh berkesan',
    '收费名称': 'Nama caj',
    '确定移除 ': 'Sahkan penyingkiran',
    '充值(次)': 'Isi semula (kali)',
    '优惠券链接不超过300个字': 'Pautan kupon tidak boleh melebihi 300 aksara',
    '学校信息管理': 'Pengurusan maklumat sekolah',
    '返回': 'kembali',
    '当前仅支持docx、xlsx、xls、ppt、pptx、mp4文件的上传': 'Pada masa ini hanya menyokong muat naik fail docx, xlsx, xls, ppt, pptx dan mp4',
    '正在同步': 'Menyegerakkan',
    '应用系统': 'sistem aplikasi',
    '请先输入商户名称': 'Sila masukkan nama pedagang dahulu',
    '存在以下订阅服务，暂不允许删除，若要删除，请先取消订阅，并进行退款': 'Perkhidmatan langganan berikut wujud dan tidak dibenarkan untuk dipadamkan. Jika anda ingin memadamkannya, sila batalkan langganan dahulu dan buat bayaran balik.',
    '收款码名称不能为空': 'Nama kod pembayaran tidak boleh kosong',
    '仅刷卡闸门设备有分进和出两个方向，其他设备中': 'Hanya peralatan pintu leret kad mempunyai dua arah, masuk dan keluar Dalam peralatan lain,',
    '消费收入统计': 'Statistik pendapatan penggunaan',
    '创建账单': 'Buat bil',
    '导入数据': 'Import data',
    '人脸识别闸门2': 'Gerbang pengecaman muka 2',
    '删除中...': 'Memadamkan...',
    '关闭成功': 'Berjaya ditutup',
    '科目管理': 'Pengurusan akaun',
    '收款码名称：': 'Nama kod pembayaran:',
    '添加考试': 'Tambah peperiksaan',
    '对象范围：': 'Skop objek:',
    '请输入优惠券链接': 'Sila masukkan pautan kupon',
    '请输入商户名称': 'Sila masukkan nama pedagang',
    '现金充值': 'Tambah nilai tunai',
    '订餐': 'Pesan makanan',
    '账户': 'Akaun',
    '请输入最短未识别间隔（分钟）': 'Sila masukkan selang minimum yang tidak dikenali (minit)',
    '当前学生': 'pelajar semasa',
    '请上传封面': 'Sila muat naik muka depan',
    '学生姓名最大长度为50个字': 'Panjang maksimum nama pelajar ialah 50 aksara',
    '就餐时间': 'Masa makan',
    '上传文件不能为空': 'Muat naik fail tidak boleh kosong',
    '请上传人脸照片匹配表': 'Sila muat naik jadual padanan foto wajah',
    '秒': 'Kedua',
    '退出全屏': 'Keluar dari skrin penuh',
    '禁止通行': 'Tiada akses',
    '分账商户号': 'Nombor peniaga akaun cawangan',
    '校园缴费表格模板.xlsx': 'Templat borang pembayaran kampus.xlsx',
    '在读': 'Membaca',
    '设备类型': 'Jenis peranti',
    '近期更新': 'Kemas kini terkini',
    '确定要删除': 'Sahkan untuk memadam',
    '获取成绩科目列表失败, 请刷新重试': 'Gagal mendapatkan senarai mata pelajaran yang dinilai, sila muat semula dan cuba lagi.',
    '系统繁忙，请重新上传': 'Sistem sedang sibuk, sila muat naik semula',
    '上传人脸照片压缩文件,仅支持zip格式': 'Muat naik fail mampat foto muka, hanya format zip disokong',
    '腾讯': 'Tencent',
    '删除科目失败-else, 请刷新重试': 'Gagal memadamkan akaun -lain, sila muat semula dan cuba lagi',
    '关系': 'perhubungan',
    '已识别': 'Diiktiraf',
    '收费名称不超过50个字': 'Nama yuran tidak boleh melebihi 50 aksara',
    '至': 'kepada',
    '此操作将永久删除该学生, 是否继续?': 'Operasi ini akan memadamkan pelajar secara kekal. Adakah anda mahu meneruskan?',
    '操作成功': 'Operasi berjaya',
    '月考': 'peperiksaan bulanan',
    '本日充值': 'Isi semula hari ini',
    '已识别（盒）': 'Diiktiraf (kotak)',
    '二维码收费': 'Caj kod QR',
    '用户': 'pengguna',
    '未绑定': 'Tidak terikat',
    '请选择考试科目': 'Sila pilih subjek peperiksaan',
    '服务器繁忙，请刷新重试！': 'Pelayan sedang sibuk, sila muat semula dan cuba lagi!',
    '数据上传中': 'Memuat naik data',
    '彩色小摆闸：21及其以上版本，低版本的请先升级': 'Pintu buaian kecil berwarna-warni: versi 21 dan ke atas, sila tingkatkan dahulu jika anda mempunyai versi yang lebih rendah',
    '最短未识别间隔（分钟）': 'Selang minimum tidak dikenali (minit)',
    '周六': 'Sabtu',
    '无需激活': 'Tiada pengaktifan diperlukan',
    '分账详情': 'Butiran akaun',
    '删除科目失败-catch, 请刷新重试': 'Gagal memadamkan akaun -catch, sila muat semula dan cuba lagi',
    '编辑模板': 'Edit templat',
    '添加成功': 'Berjaya ditambahkan',
    '中午消费(元)': 'Penggunaan tengah hari (yuan)',
    '家长数：': 'Bilangan ibu bapa:',
    '添加套餐': 'Tambah pakej',
    '请输入姓名': 'Sila masukkan nama',
    '商品信息': 'Maklumat produk',
    '全部家长': 'Semua ibu bapa',
    '请先选择发布范围': 'Sila pilih skop penerbitan dahulu',
    '孩子所属年级': 'Gred anak',
    '删除学生': 'Padam pelajar',
    '的生效时段': 'tempoh berkesan',
    '考试科': 'Bahagian Peperiksaan',
    '有效期': 'Tempoh sah laku',
    '登记类型': 'Jenis pendaftaran',
    '导出结果': 'Hasil eksport',
    '若选择“必交”，则家长必须支付后才能完成账单': 'Jika anda memilih "Mesti Bayar", ibu bapa mesti membayar sebelum melengkapkan bil.',
    '输入抓拍图片链接': 'Masukkan pautan syot kilat',
    '考试时间': 'masa peperiksaan',
    '人脸识别闸门1代：时段内设备暂停更新所有数据；人脸识别闸门2代：时段内设备仅暂停更新人脸数据。': 'Gerbang pengecaman muka 1: peranti menangguhkan pengemaskinian semua data dalam tempoh tersebut; gerbang pengecaman muka 2: peranti hanya menangguhkan pengemaskinian data muka dalam tempoh tersebut.',
    '门禁规则添加成功': 'Peraturan kawalan akses berjaya ditambahkan',
    '三次识别': 'Pengiktirafan tiga kali ganda',
    '当前账单已截止收费，无法进行催交': 'Bil semasa telah dicaj dan pembayaran tidak dapat disegerakan.',
    '未划分年级': 'Tidak dibahagikan kepada gred',
    '一次只能上传一个excel文件，请删除再上传': 'Hanya satu fail excel boleh dimuat naik pada satu masa, sila padamkannya dan muat naik semula.',
    '刷新': 'segarkan semula',
    '请先选择学校': 'Sila pilih sekolah dahulu',
    '消费系统': 'sistem penggunaan',
    '未识别': 'Tidak diiktiraf',
    '已识别（TX1）': 'Diiktiraf (TX1)',
    '导入成功，': 'Import berjaya,',
    '接口异常，请稍后重试': 'Pengecualian antara muka, sila cuba lagi kemudian',
    '当前所处地点': 'Lokasi semasa',
    '课程管理': 'Pengurusan kursus',
    '默认设置': 'Tetapan lalai',
    '请输入考试名称': 'Sila masukkan nama peperiksaan',
    '获取成绩科目列表失败-catch, 请刷新重试': 'Gagal mendapatkan senarai mata pelajaran gred -tangkap, sila muat semula dan cuba lagi',
    '微信收入统计': 'Statistik pendapatan WeChat',
    '下载模板': 'Muat turun templat',
    '搜索用户': 'Cari pengguna',
    '监控管理': 'Pemantauan dan pengurusan',
    '人脸识别已关闭': 'Pengecaman muka dimatikan',
    '明细': 'Butiran',
    '仅支持docx、xlsx、xls、ppt、pptx、mp4文件上传,请重新选择': 'Hanya menyokong muat naik fail docx, xlsx, xls, ppt, pptx, mp4, sila pilih semula',
    '用户类型': 'Jenis pengguna',
    '同步家长数据': 'Segerakkan data induk',
    '类型': 'menaip',
    '生效中': 'Berkuatkuasa',
    '成功': 'kejayaan',
    '条数据同步成功，': 'Penyegerakan data berjaya,',
    '请选择考试时间': 'Sila pilih masa peperiksaan',
    '设置管理': 'Pengurusan tetapan',
    '所有渠道': 'Semua saluran',
    '一键催交': 'Satu klik mempercepatkan',
    '文本': 'teks',
    '请输入正确的学生卡': 'Sila masukkan kad pelajar yang betul',
    '学号：': 'ID Pelajar:',
    '学生：全部学生': 'Pelajar: semua pelajar',
    '该学校暂未划分年级': 'Sekolah masih belum dibahagikan kepada gred',
    '套餐': 'kombo',
    '年级班级': 'kelas gred',
    '规则结束日期': 'Tarikh tamat peraturan',
    '免费试听': 'Percubaan percuma',
    '结果备注': 'Nota keputusan',
    '校园卡号：': 'Nombor kad kampus:',
    '同步年级班级数据': 'Segerakkan data gred dan kelas',
    '职工管理': 'pengurusan pekerja',
    '请上传格式为xlsx的文件': 'Sila muat naik fail dalam format xlsx',
    '获取考试详情失败, 请刷新重试': 'Gagal mendapatkan butiran peperiksaan, sila muat semula dan cuba lagi',
    '考试科目': 'Subjek peperiksaan',
    '通过学生标识订餐': 'Pesan makanan dengan ID pelajar',
    '请选择学校': 'Sila pilih sekolah',
    '取消激活': 'Nyahaktifkan',
    '运营人员': 'Kakitangan operasi',
    '分账关系': 'Perhubungan perkongsian akaun',
    '标题不能为空': 'Tajuk tidak boleh kosong',
    '部分交费': 'Bayaran separa',
    '腾讯库同步': 'Penyegerakan perpustakaan Tencent',
    '中午': 'tengah hari',
    '请输入大于0的整数': 'Sila masukkan integer lebih besar daripada 0',
    '设置统计范围': 'Tetapkan julat statistik',
    '截止日期不能为空': 'Tarikh akhir tidak boleh kosong',
    '人脸库同步期间，人脸识别功能不可用。你确定要同步？': 'Semasa penyegerakan pangkalan data muka, fungsi pengecaman muka tidak tersedia. Adakah anda pasti mahu menyegerakkan?',
    '请勿重复操作': 'Jangan ulangi operasi',
    '请添加模板封面': 'Sila tambahkan penutup templat',
    '学校商户关闭分账状态失败': 'Pedagang sekolah gagal menutup status akaun berasingan',
    '支持扩展名：.xls .xlsx': 'Sambungan yang disokong: .xls .xlsx',
    '帮助中心': 'Pusat Bantuan',
    '模板标题': 'Tajuk templat',
    '导入结果': 'Hasil import',
    '批量编辑': 'Pengeditan kelompok',
    '支付信息': 'Maklumat pembayaran',
    '正在导出表格，请勿重复操作': 'Mengeksport jadual, sila jangan ulangi operasi',
    '生效时': 'apabila berkesan',
    '人脸录入时间': 'Masa rakaman muka',
    '职工：': 'kakitangan:',
    '职工姓名': 'Nama pekerja',
    '发布考试失败, 请刷新重试': 'Gagal menerbitkan peperiksaan, sila muat semula dan cuba lagi',
    '5、点击“确定”按钮，开始批量导入。': '5. Klik butang "OK" untuk memulakan import kelompok.',
    '关闭': 'penutupan',
    '管理平台': 'Platform pengurusan',
    '请搜索权限名称': 'Sila cari nama kebenaran',
    '职工总数': 'Jumlah bilangan pekerja',
    '名单收费': 'Bayaran senarai',
    '请先输入分账商户列表的分账比例': 'Sila masukkan nisbah pecahan senarai pedagang berpecah dahulu.',
    '门禁规则': 'Peraturan kawalan akses',
    '二次识别阈值不能为0': 'Ambang pengecaman sekunder tidak boleh 0',
    '三、填写人脸信息匹配表要求': '3. Isikan keperluan borang padanan maklumat muka',
    '下载': 'muat turun',
    '高': 'tinggi',
    '[舔屏]': '[layar jilat]',
    '活体检测': 'Pengesanan liveness',
    '添加角色': 'Tambah peranan',
    '已暂停': 'Digantung',
    '选择算法': 'algoritma pemilihan',
    '期中': 'Pertengahan penggal',
    '添加科目失败-catch, 请刷新重试': 'Gagal menambah akaun -catch, sila muat semula dan cuba lagi',
    '录入照片': 'Masukkan foto',
    '成绩？': 'skor?',
    '人脸库同步提醒': 'Peringatan penyegerakan pangkalan data muka',
    '需要统计的设备': 'Peranti yang memerlukan statistik',
    '已失败': 'gagal',
    '一次识别阈值必须大于0': 'Ambang pengiktirafan mestilah lebih besar daripada 0',
    '导入失败，你可以下载导入失败的信息表，修改后重新上传': 'Import gagal Anda boleh memuat turun jadual maklumat yang gagal mengimport, mengubah suai dan memuat naiknya semula.',
    '导出数据': 'Eksport data',
    '本日统计': 'Statistik hari ini',
    '查看详情': 'semak butiran',
    '编辑家长': 'Edit ibu bapa',
    '批量取消订餐': 'Batalkan pesanan secara pukal',
    '保 存': 'jimat',
    '适用日期': 'Tarikh berkenaan',
    '上传视频不能大于100MB,请重新选择': 'Video yang dimuat naik tidak boleh lebih besar daripada 100MB, sila pilih sekali lagi.',
    '分账商户：': 'Pedagang akaun cawangan:',
    '晚上': 'malam',
    '以下用户的人脸同步到腾讯库失败。为不影响人脸识别，请通知对应用户重新录入人脸': 'Penyegerakan muka pengguna berikut ke pangkalan data Tencent gagal. Untuk tidak menjejaskan pengecaman muka, sila maklumkan pengguna yang sepadan untuk memasukkan semula muka.',
    '返回旧版': 'Kembali ke versi lama',
    '消费统计': 'statistik penggunaan',
    '支付账单': 'bayar bil',
    '修改': 'Semak semula',
    '添加模板': 'Tambah templat',
    '重复周期': 'Ulangi kitaran',
    '获取考试列表失败, 请刷新重试': 'Gagal mendapatkan senarai peperiksaan, sila muat semula dan cuba lagi',
    '3、按要求采集人脸照片，打成zip压缩包，上传到后台。': '3. Kumpul foto muka seperti yang diperlukan, jadikan ia menjadi fail zip dan muat naiknya ke bahagian belakang.',
    '按日统计': 'Statistik mengikut hari',
    '请选择是否为绝对地址': 'Sila pilih sama ada ia adalah alamat mutlak',
    '消费方式': 'Corak penggunaan',
    '鼠标移到此处查看支持的设备和版本': 'Gerakkan tetikus anda ke sini untuk melihat peranti dan versi yang disokong',
    '获取导出数据失败，请刷新重试': 'Gagal mendapatkan data eksport, sila muat semula dan cuba lagi',
    '请输入大于0且小于等于350的整数': 'Sila masukkan integer lebih besar daripada 0 dan kurang daripada atau sama dengan 350',
    '选择日期': 'Pilih tarikh',
    '提 交': 'menyerahkan',
    '添加校园卡': 'Tambah kad kampus',
    '上传人脸照片压缩包': 'Muat naik pakej mampat foto muka',
    '更新`': 'Kemas kini`',
    '按用户统计': 'Statistik mengikut pengguna',
    '确定停止后，当前账单将停止收费，家长无法完成支付，已支付的数据系统将保留，是否继续执行': 'Selepas mengesahkan pemberhentian, bil semasa akan berhenti mengecaj, ibu bapa tidak akan dapat menyelesaikan pembayaran, dan data berbayar akan disimpan oleh sistem Adakah anda mahu meneruskan?',
    '2、下载“采集人脸照片要求、人脸照片信息匹配表”。': '2. Muat turun "Keperluan untuk Mengumpul Foto Wajah dan Jadual Padanan untuk Maklumat Foto Wajah".',
    '确认删除该条模板?': 'Adakah anda pasti akan memadamkan templat ini?',
    '编辑': 'edit',
    '长度最多为 100 个字符': 'Panjang boleh sehingga 100 aksara',
    '校园管理平台': 'Platform pengurusan kampus',
    '职工：全部职工': 'Pekerja: semua pekerja',
    '消费(次)': 'Penggunaan (kali)',
    '简介': 'pengenalan',
    '识别记录': 'Kenal pasti rekod',
    '发布中...': 'Terbitkan...',
    '选择商户': 'Pilih peniaga',
    '允许通行': 'dibenarkan lulus',
    '永久有效': 'Sah selama-lamanya',
    '请先填写通知内容': 'Sila isi kandungan pemberitahuan terlebih dahulu',
    '等': 'tunggu',
    '若选择“自愿”，则家长可以选择“不参与”，即完成该账单': 'Jika "sukarela" dipilih, ibu bapa boleh memilih "tidak menyertai" untuk melengkapkan bil',
    '此操作将删除该家长, 是否继续?': 'Operasi ini akan memadamkan ibu bapa Adakah anda mahu meneruskan?',
    '调整收费时间': 'Laraskan masa pengecasan',
    '修改考试失败, 请刷新重试': 'Gagal mengubah suai peperiksaan, sila muat semula dan cuba lagi',
    '考勤': 'Kehadiran',
    '描述不能为空': 'Perihalan tidak boleh kosong',
    '添加分账商户': 'Tambah pedagang akaun cawangan',
    '微信绑定情况': 'Status mengikat WeChat',
    '剩余激活年': 'baki tahun pengaktifan',
    '保存成功': 'Berjaya disimpan',
    '统计方式': 'Kaedah statistik',
    '学籍状态：': 'Status Pelajar:',
    '①请填写职工所属的“照片名称”即可。(如“王校长”，不用填写文件拓展名)': '① Sila isikan "nama foto" pekerja. (Sebagai contoh, "Principal Wang", tidak perlu mengisi sambungan fail)',
    '请输入用户名或卡号': 'Sila masukkan nama pengguna atau nombor kad',
    '设置': 'sediakan',
    '请输入课程简介': 'Sila masukkan pengenalan kursus',
    '请选择参加考试的班级': 'Sila pilih kelas di mana anda akan mengambil peperiksaan',
    '需要统计的商户': 'Peniaga yang memerlukan statistik',
    '资金存管': 'Depositori dana',
    '迟到就餐人次': 'Ketibaan lewat',
    '添加科目名': 'Tambah nama akaun',
    '催交': 'mempercepatkan',
    '设置学校收费接口失败': 'Gagal menyediakan antara muka pengecasan sekolah',
    '课程封面': 'Penutup kursus',
    '解除绑定': 'Buka ikatan',
    '考试名称': 'Nama peperiksaan',
    '本周充值': 'Isi semula minggu ini',
    '基础信息': 'Maklumat asas',
    '上传人脸zip文件失败': 'Gagal memuat naik fail zip muka',
    '请输入app_id': 'Sila masukkan app_id',
    '学生总数': 'jumlah bilangan pelajar',
    '确认后，账单状态将修改为“未支付”，学生家长需完成账单的支付，是否继续执行': 'Selepas pengesahan, status bil akan ditukar kepada "Tidak Dibayar".',
    '撤销支付信息': 'Batalkan maklumat pembayaran',
    '就餐方式': 'Gaya makan',
    '请选择班级': 'Sila pilih kelas',
    '学生标识': 'ID pelajar',
    '开启成功': 'Berjaya dibuka',
    '封面': 'penutup',
    '上传文件': 'Muat naik fail',
    '路径不能为空': 'Laluan tidak boleh kosong',
    '删除成功!': 'Pemadaman berjaya!',
    '删除失败，请重试': 'Pemadaman gagal, sila cuba lagi',
    '后门': 'pintu belakang',
    '人脸照片匹配表(职工)': 'Jadual padanan foto muka (pekerja)',
    '描述（不超过 100 个字符）': 'Perihalan (tidak lebih daripada 100 aksara)',
    '学生姓名': 'nama pelajar',
    '禁止进出': 'tiada masuk atau keluar',
    '分账金额': 'Amaun sub-akaun',
    '确定删除该权限': 'Sahkan untuk memadamkan kebenaran ini',
    '背景颜色': 'warna latar belakang',
    '请输入学号': 'Sila masukkan nombor pelajar',
    '设备信息': 'Maklumat peranti',
    '发布范围': 'Skop pelepasan',
    '学生信息': 'maklumat pelajar',
    '请输入组件名': 'Sila masukkan nama komponen',
    '获取下载数据失败，请刷新重试': 'Gagal mendapatkan data muat turun, sila muat semula dan cuba lagi',
    '全选': 'Pilih semua',
    '设备管理': 'Pengurusan peranti',
    '关 闭': 'penutupan',
    '未激活': 'Tidak diaktifkan',
    '家长：全部家长': 'Ibu bapa: Semua ibu bapa',
    '现金支出合计(元)': 'Jumlah pengeluaran tunai (yuan)',
    '此操作将解除绑定, 是否继续?': 'Operasi ini akan melepaskan ikatan, adakah anda mahu meneruskan?',
    '获取班级列表失败, 请刷新重试': 'Gagal mendapatkan senarai kelas, sila muat semula dan cuba lagi',
    '早上消费(元)': 'Penggunaan pagi (yuan)',
    '选择代理商': 'Pilih ejen',
    '禁用': 'Lumpuhkan',
    '上传文档不能大于10MB,请重新选择': 'Dokumen yang dimuat naik tidak boleh lebih besar daripada 10MB, sila pilih sekali lagi.',
    '上传成功': 'Muat naik berjaya',
    '小时': 'jam',
    '一、批量录入人脸步骤': '1. Langkah-langkah untuk memasukkan muka secara berkelompok',
    '适用设备': 'Peralatan yang berkenaan',
    '就餐统计': 'Statistik Makan',
    '单元测试': 'Ujian unit',
    '修改直播间': 'Ubah suai bilik siaran langsung',
    '暂无失败数据': 'Tiada data kegagalan lagi',
    '该门禁规则不用生效的特殊日期': 'Peraturan kawalan akses ini tidak memerlukan tarikh khas untuk berkuat kuasa.',
    '期末': 'Akhir penggal',
    '发布时间：': 'Masa keluaran:',
    '建议尺寸：333*206，不超过1M，格式：jpg、jpeg、gif、png': 'Saiz yang disyorkan: 333*206, tidak lebih daripada 1M, format: jpg, jpeg, gif, png',
    '刷脸图片': 'Gambar memberus muka',
    '所选导出数据为0条': 'Data eksport yang dipilih ialah 0',
    '服务器繁忙，请刷新重试': 'Pelayan sedang sibuk, sila muat semula dan cuba lagi.',
    '数字': 'nombor',
    '学生管理': 'pengurusan pelajar',
    '班': 'kelas',
    '错误详情': 'Butiran ralat',
    '\'学校名称：': '\'Nama sekolah:',
    '系统ID': 'ID Sistem',
    '下载完成': 'Muat turun selesai',
    '选择设备': 'Pilih peranti',
    '请输入密码': 'Sila masukkan kata laluan',
    '配置管理': 'Pengurusan konfigurasi',
    '适用人员': 'Kakitangan yang berkenaan',
    '切换身份': 'tukar identiti',
    '付款数': 'Bilangan pembayaran',
    '已选择': 'Dipilih',
    '餐次': 'Makanan',
    '请填写图标名称': 'Sila isikan nama ikon',
    '新增公众号': 'Tambah akaun rasmi baharu',
    '下载人脸照片采集说明、人脸照片信息匹配表': 'Muat turun arahan pengumpulan foto muka dan jadual pemadanan maklumat foto muka',
    '状态': 'negeri',
    '添加': 'Tambah ke',
    '考试班': 'kelas peperiksaan',
    '添加家长': 'tambah ibu bapa',
    '最大未识别阈值不能小于等于最小识别阈值': 'Ambang maksimum yang tidak dikenal pasti tidak boleh kurang daripada atau sama dengan ambang minimum yang dikenal pasti',
    '失败记录': 'Rekod kegagalan',
    '修改身份': 'Ubah suai identiti',
    '请选择发布人': 'Sila pilih penerbit',
    '操作': 'beroperasi',
    '添加科目失败-else, 请刷新重试': 'Gagal menambah akaun -else, sila muat semula dan cuba lagi',
    '请输入内容': 'Sila masukkan kandungan',
    '否': 'tidak',
    '请选择': 'Sila pilih',
    '请输入收费名称': 'Sila masukkan nama caj',
    '选择时间范围': 'Pilih julat masa',
    '就餐规则': 'Peraturan makan',
    '现金': 'tunai',
    '年级班级：': 'Kelas gred:',
    '暂无数据': 'Tiada data lagi',
    '进出设': 'Kemudahan keluar masuk',
    '已分账': 'Sudah berbelah bahagi',
    '提交内容失败-else': 'Gagal menyerahkan kandungan lain',
    '规则名称最长20个字，请重新填写': 'Panjang maksimum nama peraturan ialah 20 aksara Sila isi semula.',
    '固定金额': 'jumlah tetap',
    '考试班级': 'kelas peperiksaan',
    '撤销后，线下支付的支付信息将会清除且不能恢复，是否继续': 'Selepas pembatalan, maklumat pembayaran untuk pembayaran luar talian akan dikosongkan dan tidak boleh dipulihkan Adakah anda mahu meneruskan?',
    '商户配置修改成功': 'Konfigurasi pedagang berjaya diubah suai',
    '请输入学生卡': 'Sila masukkan kad pelajar anda',
    '暂不允许删除，若要删除，请先取消以下订阅': 'Pemadaman tidak dibenarkan pada masa ini Jika anda ingin memadam, sila batalkan langganan berikut terlebih dahulu.',
    '1、请填写学生所属的“照片名称”即可。(如“小明”，不用填写文件拓展名)': '1. Sila isikan "photo name" pelajar. (Sebagai contoh, "Xiao Ming", tidak perlu mengisi sambungan fail)',
    '选择范围：': 'Julat pilihan:',
    '账户余额': 'Baki akaun',
    '发布': 'lepaskan',
    '选填项，选择家长': 'Pilihan, pilih ibu bapa',
    '输入模板标题，不超过40个字': 'Masukkan tajuk templat, tidak lebih daripada 40 patah perkataan',
    '批量订餐': 'Pesanan pukal',
    '选填项，选择职位': 'Pilihan, pilih kedudukan',
    '识别阈值：': 'Ambang pengiktirafan:',
    '查看结果': 'Lihat keputusan',
    '周': 'minggu',
    '本周统计': 'Statistik untuk minggu ini',
    '请选择学籍状态': 'Sila pilih status pelajar',
    '收费截止时间修改成功': 'Tarikh akhir caj berjaya diubah suai',
    '订单号': 'Nombor pesanan',
    '请选择代理商': 'Sila pilih ejen',
    '请输入': 'Sila masukkan',
    '取消': 'Batal',
    '按时段统计': 'Statistik mengikut tempoh masa',
    '取现(次)': 'Pengeluaran tunai (kali)',
    '请选择年级': 'Sila pilih gred',
    '规则更新成功': 'Peraturan berjaya dikemas kini',
    '标记': 'tanda',
    '自愿': 'secara sukarela',
    '手机号码*': 'nombor telefon*',
    '搜索': 'cari',
    '全部': 'semua',
    '生效时段': 'Tempoh berkesan',
    '已取消': 'Dibatalkan',
    '姓名': 'Nama',
    '代理商名称：': 'Nama ejen:',
    '按月统计': 'Statistik mengikut bulan',
    '收费说明：': 'Perihalan caj:',
    '闸门设备：63及其以上版本，低版本的请先升级': 'Peralatan pintu: versi 63 dan ke atas Jika anda mempunyai versi yang lebih rendah, sila tingkatkan dahulu.',
    '创建日期': 'Tarikh penciptaan',
    '修改密码': 'Tukar kata laluan',
    '姓名：': 'nama:',
    '时间段设置有重叠，请检查后重新保存': 'Tetapan tempoh masa bertindih, sila semak dan simpan semula.',
    '期间的支付记录': 'Rekod pembayaran sepanjang tempoh tersebut',
    '的重复周期': 'tempoh pengulangan',
    '服务管理': 'Pengurusan perkhidmatan',
    '操作失败,未查询到': 'Operasi gagal, tidak dijumpai',
    '消费(元)': 'Penggunaan (yuan)',
    '全部职工': 'Semua pekerja',
    '流水记录': 'rekod air mengalir',
    '删除全部门禁规则后，才允许切换': 'Penukaran hanya dibenarkan selepas memadamkan semua peraturan akses.',
    '已发布': 'Diterbitkan',
    '按商户设置': 'Ditetapkan oleh peniaga',
    '支付宝': 'Alipay',
    '请选择权限': 'Sila pilih kebenaran',
    '模板封面': 'penutup templat',
    '按设备设置': 'Tetapkan mengikut peranti',
    '获取年级班级列表失败, 请刷新重试': 'Gagal mendapatkan senarai kelas gred, sila muat semula dan cuba lagi',
    '卡号': 'nombor kad',
    '项目名称': 'Nama projek',
    '微信单号': 'Nombor tunggal WeChat',
    '请输入考试名称，不超过20个字': 'Sila masukkan nama peperiksaan, tidak lebih daripada 20 aksara',
    '●照片支持jpg. jpeg. png格式， 要求不小于800*800像素。': '●Foto menyokong format jpg jpeg, memerlukan tidak kurang daripada 800*800 piksel.',
    '绝对地址': 'alamat mutlak',
    '所有': 'semua',
    '金额类型': 'Jenis amaun',
    '关联公众号信息不全，请先补充完整': 'Maklumat yang dikaitkan dengan akaun awam tidak lengkap, sila lengkapkan dahulu',
    '商户名称': 'Nama saudagar',
    '上传填写后的人脸照片匹配表,仅支持xlsx格式': 'Muat naik borang padanan foto wajah yang lengkap, hanya format xlsx disokong',
    '个文件': 'fail',
    '操作失败, 请刷新重试': 'Operasi gagal, sila muat semula dan cuba lagi',
    '同步学生数据': 'Segerakkan data pelajar',
    '模拟': 'simulasi',
    '确定催交后，系统将发送账单的推送提醒给未交费的家长用户，1天内仅能催交1次，是否继续执行': 'Selepas pembayaran disahkan, sistem akan menghantar peringatan tolak bil kepada pengguna induk yang belum membayar Bayaran hanya boleh digesa sekali dalam sehari.',
    '上传名单(支持按单个学生设置不同收费金额)': 'Muat naik senarai (menyokong menetapkan jumlah yuran yang berbeza mengikut pelajar individu)',
    '提交': 'menyerahkan',
    '请先选择用户类型': 'Sila pilih jenis pengguna dahulu',
    '功能说明': 'Penerangan fungsi',
    '人脸识别': 'pengecaman muka',
    '添加规则': 'Tambah peraturan',
    '请等待压缩包或匹配表文件上传完成，再进行该切换': 'Sila tunggu sehingga pakej termampat atau fail jadual yang sepadan dimuat naik sebelum melakukan suis ini.',
    '未就餐人次': 'Bilangan orang yang tidak makan',
    '批量录入操作': 'Operasi kemasukan kelompok',
    '③填写表格时， 请勿修改“系统ID、孩子所属年级、孩子所属班级、孩子姓名、家长手机号”。': '③Semasa mengisi borang, sila jangan ubah suai "ID sistem, tahap gred kanak-kanak, kelas kanak-kanak, nama anak, nombor telefon bimbit ibu bapa".',
    '毕业': 'graduan',
    '请选择要搜索的学校': 'Sila pilih sekolah yang anda ingin cari',
    '密码': 'kata laluan',
    '学校列表': 'senarai sekolah',
    '播报名称最大长度为20个字': 'Panjang maksimum nama siaran ialah 20 aksara',
    '获取导出数据失败, 请刷新重试': 'Gagal mendapatkan data eksport, sila muat semula dan cuba lagi',
    '课程链接不超过300个字': 'Pautan kursus tidak boleh melebihi 300 patah perkataan',
    '●被拍摄者需要平视镜头，不准低头歪头，眼睛眉毛需要清晰可见，头发不准遮挡到眉毛。': '●Orang yang difoto perlu melihat terus ke arah kamera, dan tidak dibenarkan menundukkan atau memiringkan kepalanya.',
    '模板分类': 'Klasifikasi templat',
    '请上传格式为zip的文件': 'Sila muat naik fail dalam format zip',
    '请选择日期': 'Sila pilih tarikh',
    '④对于已录入照片的职工，重新录入的话，新照片将会覆盖旧照片。': '④ Bagi pekerja yang gambarnya telah dimasukkan, jika mereka dimasukkan semula, foto baharu akan menimpa foto lama.',
    '支付金额': 'Jumlah bayaran',
    '排序必须为数字值': 'Isih mestilah nilai berangka',
    '选填项': 'Pilihan',
    '收费项目金额不能为0，请修改': 'Jumlah item yang dicaj tidak boleh 0, sila ubah suainya.',
    '收费截止时间调整为': 'Masa pemotongan yuran diselaraskan kepada',
    '该次考试存在未录入成绩的学生，请检查': 'Ada pelajar yang markahnya belum dimasukkan untuk peperiksaan ini, sila semak',
    '选填项，选择考勤标签': 'Pilihan, pilih tab Kehadiran',
    '代理商': 'ejen',
    '主号': 'Nombor utama',
    '设置消费时段': 'Tetapkan tempoh penggunaan',
    '设备': 'peralatan',
    '请填写一次识别阈值': 'Sila isikan ambang pengenalan sekali',
    '家长信息': 'Maklumat ibu bapa',
    '一次识别': 'Kenali sekali',
    '请先选择年级': 'Sila pilih gred anda dahulu',
    '模板内容': 'Kandungan templat',
    '当前账号没有权限访问此页面，请用指定账号查看': 'Akaun semasa tidak mempunyai kebenaran untuk mengakses halaman ini. Sila gunakan akaun yang ditetapkan untuk melihatnya.',
    '学校名称': 'nama sekolah',
    '开启': 'hidupkan',
    '组件名不能为空': 'Nama komponen tidak boleh kosong',
    '已关闭': 'tertutup',
    '黑名单': 'senarai hitam',
    '商户号': 'Nombor saudagar',
    '已结束': 'tamat',
    '成绩表': 'Lembaran markah',
    '暂无可用设备': 'Tiada peralatan tersedia lagi',
    '排序': 'menyusun',
    '前门': 'pintu depan',
    '收费对象：': 'Objek yang boleh dikenakan bayaran:',
    '家长总数': 'Jumlah bilangan ibu bapa',
    '请选择年级班级': 'Sila pilih kelas gred',
    '知识付费': 'Bayar untuk ilmu',
    '●照片名称不要带有空格，最长不要超过40个字,如“小明”。': '●Nama foto tidak boleh mengandungi ruang dan tidak boleh melebihi 40 aksara, seperti "Xiao Ming".',
    '陈小峰': 'Chen Xiaofeng',
    '账单已停止收费': 'Bill telah berhenti mengecas',
    '其它设备暂不支持，请到旧版后台设置门禁规则': 'Peranti lain belum disokong lagi. Sila pergi ke versi lama bahagian belakang untuk menetapkan peraturan kawalan akses.',
    '男': 'lelaki',
    '个班级': 'kelas',
    '是否确认删除': 'Adakah anda mengesahkan pemadaman?',
    '线上支付': 'Pembayaran dalam talian',
    '识别状态': 'Status pengenalan',
    '家长管理': 'Pengurusan ibu bapa',
    '时间单位': 'unit masa',
    '[坏笑]': '[ketawa teruk]',
    '等其他学校人脸录入完毕后,系统会自动录入该“': 'Selepas muka sekolah lain dimasukkan, sistem akan secara automatik memasuki "',
    '添加科目': 'Tambah akaun',
    '输入照片名称、学生姓名': 'Masukkan nama foto dan nama pelajar',
    '时间间隔不能超过30天': 'Selang masa tidak boleh melebihi 30 hari',
    '校园卡信息': 'Maklumat kad kampus',
    '获取学校服务收费列表接口失败': 'Gagal mendapatkan antara muka senarai yuran perkhidmatan sekolah',
    '早上': 'Pagi',
    '提交内容失败-catch': 'Gagal menyerahkan kandungan -catch',
    '查询时间': 'masa pertanyaan',
    '退款(次)': 'Bayaran balik(kali)',
    '收费设置': 'Tetapan caj',
    '正在删除学生,请勿重复操作!': 'Memadam pelajar, tolong jangan ulangi operasi!',
    '上传的图片最大尺寸为750*319!': 'Saiz maksimum imej yang dimuat naik ialah 750*319!',
    '上传失败，表格内容与模板格式不符，请修改后重新上传': 'Muat naik gagal Kandungan jadual tidak sepadan dengan format templat Sila ubah suai dan muat naik semula.',
    '是否开启分账': 'Sama ada untuk mendayakan sub-perakaunan',
    '二、采集人脸照片要求': '2. Keperluan untuk mengumpul gambar muka',
    '开始日期': 'tarikh mula',
    '确认后，该学生的账单状态将修改为“不参与”并完成账单，是否继续执行': 'Selepas pengesahan, status pengebilan pelajar akan diubah suai kepada "tidak mengambil bahagian" dan bil akan selesai Adakah anda mahu meneruskan?',
    '添加权限': 'Tambah kebenaran',
    '商户配置': 'Konfigurasi pedagang',
    '延迟时间': 'Masa kelewatan',
    '导出': 'Eksport',
    '视频文件大小不超过100M，文档文件大小不超过10M': 'Saiz fail video tidak melebihi 100M, saiz fail dokumen tidak melebihi 10M',
    '激活': 'pengaktifan',
    '孩子所属班级': 'Kelas yang dimiliki oleh kanak-kanak itu',
    '分账比例': 'Nisbah perkongsian akaun',
    '本月充值': 'Isi semula bulan ini',
    '正在编辑家长,请勿重复操作!': 'Mengedit ibu bapa, tolong jangan ulangi operasi!',
    '收费名称不能为空': 'Nama caj tidak boleh kosong',
    '权限管理': 'Pengurusan kebenaran',
    '未识别（BD2）': 'Tidak dikenali (BD2)',
    '播报名称：': 'Nama pengumuman:',
    '课程链接': 'Pautan kursus',
    '等待中': 'Menunggu',
    '手机主号': 'Nombor utama telefon bimbit',
    '手机号码：': 'nombor telefon:',
    '结束时间': 'masa akhir',
    '总分分值': 'Jumlah markah',
    '原密码': 'Kata laluan asal',
    '身份': 'identiti',
    '请输入完整姓名': 'Sila masukkan nama penuh',
    '账户类型': 'Jenis akaun',
    '未识别（BD1）': 'Tidak dikenali (BD1)',
    '确 定': 'pasti',
    '请输入模板标题': 'Sila masukkan tajuk templat',
    '收款码': 'Kod pembayaran',
    '校园缴费v1.2_后台_学校商户配置列表接口失败': 'Pembayaran kampus v1.2_backend_school antara muka senarai konfigurasi pedagang gagal',
    '所选年级中不存在班级，请先前往添加': 'Tiada kelas dalam gred yang dipilih, sila pergi untuk menambahnya dahulu',
    '更新学校收费开关接口失败': 'Gagal mengemas kini antara muka suis yuran sekolah',
    '分账商户的分账比例总和不能超过': 'Jumlah nisbah perkongsian akaun bagi pedagang perkongsian akaun tidak boleh melebihi',
    '常规账户': 'akaun biasa',
    '去选择': 'untuk memilih',
    '收款码名称': 'Nama kod pembayaran',
    '商户': 'saudagar',
    '未支付': 'Tidak dibayar',
    '账单详情': 'Butiran bil',
    '通知内容：': 'Kandungan pemberitahuan:',
    '最小脸部：': 'Muka minimum:',
    '人脸库同步': 'Penyegerakan pangkalan data muka',
    '选择分类': 'Pilih kategori',
    '获取年级列表失败请刷新重试': 'Gagal mendapatkan senarai gred Sila muat semula dan cuba lagi.',
    '请上传人脸照片压缩包': 'Sila muat naik pakej foto muka yang dimampatkan',
    '性别：': 'jantina:',
    '长度最多为 24 个字符': 'Panjang boleh sehingga 24 aksara',
    '④对于已录入照片的家长，重新录入的话，新照片将会覆盖旧照片。': '④Untuk ibu bapa yang gambarnya telah dimasukkan, jika mereka dimasukkan semula, foto baharu akan menimpa foto lama.',
    '照片': 'foto',
    '●不要在逆光、强光、阴暗的环境拍摄照片，不要二次翻拍已有的人脸照片。': '●Jangan ambil foto dalam cahaya latar, cahaya terang atau persekitaran gelap dan jangan ambil gambar semula foto muka sedia ada.',
    '课程名称不超过30个字': 'Nama kursus tidak boleh melebihi 30 aksara',
    '全部学生': 'Semua pelajar',
    '日期': 'tarikh',
    '只出不进': 'Hanya keluar tetapi tidak masuk',
    '已成功上传该附件': 'Lampiran telah berjaya dimuat naik',
    '①请填写家长所属的“照片名称”即可。(如“李妈妈”，不用填写文件拓展名)': '① Sila isikan "nama foto" ibu bapa. (Sebagai contoh, "Mama Li", tidak perlu mengisi sambungan fail)',
    '①请填写学生所属的“照片名称”即可。(如“小明”，不用填写文件拓展名)': '① Sila isikan "nama foto" ibu bapa. (Sebagai contoh, "Ming Xiao", tidak perlu mengisi sambungan fail)',
    '无': 'tiada',
    '请选择是否为导航菜单': 'Sila pilih sama ada ia adalah menu navigasi',
    '订餐人数': 'Bilangan orang yang memesan',
    '日': 'hari',
    '发布成功': 'Disiarkan dengan jayanya',
    '收费名称：': 'Nama caj:',
    '请选择要添加考试的学校': 'Sila pilih sekolah tempat anda ingin menambah ujian',
    '消费合计(元)': 'Jumlah penggunaan (yuan)',
    '已交费': 'Yuran dibayar',
    '产品管理': 'pengurusan produk',
    '未知': 'tidak diketahui',
    '预计还需': 'Dijangka lebih banyak lagi',
    '微信': 'WeChat',
    '创建时间': 'masa penciptaan',
    '门禁动作': 'Tindakan kawalan akses',
    '请选择渠道': 'Sila pilih saluran',
    '请输入商户号': 'Sila masukkan nombor pedagang',
    '下载失败记录': 'Muat turun rekod kegagalan',
    '按日期统计': 'Statistik mengikut tarikh',
    '一': 'satu',
    '人脸识别闸门1代：支持全部版本': 'Gerbang pengecaman muka 1: menyokong semua versi',
    '人脸录入完毕后,系统会自动录入该“': 'Selepas muka dimasukkan, sistem secara automatik akan memasukkan "',
    '请搜索角色名称': 'Sila cari nama watak',
    '输入关键字进行过滤': 'Masukkan kata kunci untuk ditapis',
    '三': 'tiga',
    '描述': 'huraikan',
    '人脸识别闸门2代：91及其以上版本，低版本的请先升级': 'Gerbang pengecaman muka 2: versi 91 dan ke atas, sila tingkatkan dahulu jika anda mempunyai versi yang lebih rendah.',
    '请填写模板内容': 'Sila isi kandungan templat',
    '校园缴费v1.2_后台_分账关系列表接口失败': 'Bayaran Kampus v1.2_Backend_Akaun Perkongsian Antara Muka Senarai Perhubungan Gagal',
    '同步结果': 'Hasil penyegerakan',
    '附件：': 'lampiran:',
    '未识别（TX1）': 'Tidak dikenali (TX1)',
    '暂无年级数据': 'Tiada data gred lagi',
    '请先选择代理商或者学校': 'Sila pilih ejen atau sekolah dahulu',
    '通知标题：': 'Tajuk pemberitahuan:',
    '选择名单': 'Pilih senarai',
    '创建收款码': 'Buat kod pembayaran',
    '宿舍': 'asrama',
    '不需要统计的设备': 'Peranti yang tidak memerlukan statistik',
    '老师': 'cikgu',
    '所有代理商': 'Semua ejen',
    '选择文件失败,请刷新重试': 'Gagal memilih fail, sila muat semula dan cuba lagi',
    '个': 'individu',
    '相似度': 'persamaan',
    '未识别相似度': 'Persamaan tidak diiktiraf',
    '路由配置': 'Konfigurasi penghalaan',
    '二次识别活体阈值': 'Pengenalpastian sekunder ambang badan hidup',
    '是': 'ya',
    '请输入收款码名称': 'Sila masukkan nama kod pembayaran',
    '请输入正确的手机号': 'Sila masukkan nombor telefon bimbit yang betul',
    '未交费': 'Tidak dibayar',
    '所有学校': 'Semua sekolah',
    '只进不出': 'Hanya masuk tetapi tidak keluar',
    '正在上传，请勿重复点击': 'Memuat naik, sila jangan klik berulang kali',
    '学生姓名：': 'Nama pelajar:',
    '一次只能上传一个zip文件，请删除再上传': 'Hanya satu fail zip boleh dimuat naik pada satu-satu masa, sila padamkannya dan muat naik semula.',
    '对象范围不能为空': 'Julat objek tidak boleh kosong',
    '收费项目：': 'Caj item:',
    '相似人': 'Orang yang serupa',
    '温馨提示：若是开启人脸收费业务的学校，请先确认学生的剩余可用人脸数量。': 'Peringatan hangat: Jika anda sekolah yang telah mendayakan perniagaan pengecasan muka, sila sahkan jumlah baki muka yang tersedia untuk pelajar dahulu.',
    '点击上传': 'Klik untuk memuat naik',
    '获取年级列表失败, 请刷新重试': 'Gagal mendapatkan senarai gred, sila muat semula dan cuba lagi',
    '开始时间': 'masa mula',
    '删除成功': 'Berjaya memadam',
    '●将采集的照片,全部放在1个文件夹里,打包成zip压缩包': '●Letakkan semua foto yang dikumpul ke dalam satu folder dan bungkusnya ke dalam fail zip.',
    '现金统计': 'perangkaan tunai',
    '请填写规则名称': 'Sila isikan nama peraturan',
    '账单状态': 'status bil',
    '操作人员': 'pengendali',
    '不超过50个字': 'Tidak lebih daripada 50 patah perkataan',
    '开通会员': 'Buka keahlian',
    '批量配置': 'Konfigurasi kelompok',
    '进行中': 'sedang berjalan',
    '录入失败': 'Kemasukan gagal',
    '最小识别阈值不能为0': 'Ambang pengecaman minimum tidak boleh 0',
    '请添加模板背景': 'Sila tambahkan latar belakang templat',
    '科目？': 'tertuduh?',
    '研发中': 'Dalam pembangunan',
    '其它设备暂不支持': 'Peranti lain belum disokong lagi',
    '日常运营管理': 'Pengurusan operasi harian',
    '用户填写': 'Pengguna mengisi',
    '挂失': 'Laporkan kehilangan',
    '该考试你已经发布过, 不能再发布': 'Anda telah menerbitkan peperiksaan ini dan tidak boleh menerbitkannya lagi.',
    '下午消费(元)': 'Berbelanja pada waktu petang (yuan)',
    '关闭所有': 'Tutup semua',
    '修改权限': 'Ubah suai kebenaran',
    '激活时': 'Apabila diaktifkan',
    '上传的图片最大尺寸为333*206!': 'Saiz maksimum imej yang dimuat naik ialah 333*206!',
    '考试类型': 'Jenis peperiksaan',
    '选择一次识别算法': 'Pilih algoritma pengecaman',
    '登记信息不全，请先补充完整': 'Maklumat pendaftaran tidak lengkap, sila lengkapkan dahulu',
    '学生': 'pelajar',
    '年': 'tahun',
    '周日': 'Ahad',
    '请输入课程链接': 'Sila masukkan pautan kursus',
    '批量': 'kumpulan',
    '休学': 'Rehat dari sekolah',
    '消费收支结余(元)': 'Baki penggunaan (yuan)',
    '必填项': 'Medan yang diperlukan',
    '下载表格': 'Muat turun borang',
    '发布范围：': 'Skop keluaran:',
    '取 消': 'Batal',
    '本月统计': 'Statistik untuk bulan ini',
    '已截止': 'Tarikh akhir',
    '取消时': 'Apabila membatalkan',
    '二': 'dua',
    '支付方式': 'Kaedah pembayaran',
    '停止': 'berhenti',
    '请输入标题（不超过 24 个字符）': 'Sila masukkan tajuk (tidak lebih daripada 24 aksara)',
    '设备类型：': 'Jenis peranti:',
    '请输入关键词': 'Sila masukkan kata kunci',
    '周一': 'pada hari Isnin',
    '取现(元)': 'Keluarkan wang tunai (yuan)',
    '下午': 'tengah hari',
    '五': 'lima',
    '设置方式': 'Kaedah penetapan',
    '上传文件失败': 'Muat naik fail gagal',
    '请先选择渠道': 'Sila pilih saluran dahulu',
    '2、拍摄场景要求': '2. Keperluan adegan penggambaran',
    '请输入标题，不超过50个字': 'Sila masukkan tajuk, tidak lebih daripada 50 patah perkataan',
    '选择文件：': 'Pilih fail:',
    '创建平台': 'Buat platform',
    '选择班级': 'Pilih kelas',
    '请添加背景颜色': 'Sila tambah warna latar belakang',
    '请稍后重试': 'Sila cuba lagi kemudian',
    '学生：': 'pelajar:',
    '周三': 'Rabu',
    '若为“必交”则默认勾选，且不可取消勾选，家长必须支付此项；若为“选交”，则家长可自由勾选并支付': 'Jika "Diperlukan", ia akan disemak secara lalai dan tidak boleh dinyahsemak. Ibu bapa mesti membayar item ini jika "Pilihan", ibu bapa boleh menyemak dan membayar secara percuma.',
    '二次识别': 'pengenalan sekunder',
    '激活费': 'yuran pengaktifan',
    '时间': 'masa',
    '请输入完整相似度值': 'Sila masukkan nilai persamaan yang lengkap',
    '行数': 'Bilangan baris',
    '已取消删除': 'Nyahpadam',
    '文档不能大于1MB,请重新选择': 'Dokumen tidak boleh lebih besar daripada 1MB, sila pilih sekali lagi',
    '分钟,请耐心等待': 'minit, sila tunggu dengan sabar',
    '年级': 'gred',
    '人': 'orang ramai',
    '全部设备': 'Semua peralatan',
    '正在下载数据': 'Memuat turun data',
    '三次次识别活体阈值': 'Ambang untuk mengenal pasti objek hidup tiga kali',
    '拼命加载中': 'Memuatkan dengan terdesak',
    '2、请勿修改表格模板已有的信息和格式。': '2. Tolong jangan ubah suai maklumat dan format templat borang yang sedia ada.',
    '正在添加学生卡,请勿重复操作!': 'Kad pelajar sedang ditambah, tolong jangan ulangi operasi!',
    '请选择模板分类': 'Sila pilih kategori templat',
    '危险区域': 'Kawasan bahaya',
    '启用': 'membolehkan',
    '成绩': 'skor',
    '就餐人次': 'Waktu makan',
    '即可': 'itu sahaja',
    '权限配置': 'Konfigurasi kebenaran',
    '家长：': 'ibu bapa:',
    '四': 'Empat',
    '确定后系统将执行同步': 'Selepas pengesahan, sistem akan melakukan penyegerakan',
    '该学校还没添加任何职工': 'Pihak sekolah belum menambah kakitangan lagi',
    '正在请求数据': 'Meminta data',
    '是否默认背景': 'Sama ada hendak menggunakan latar belakang lalai',
    '人脸闸门暂停更新数据时段': 'Face Gate menangguhkan tempoh kemas kini data',
    '3、打压缩包要求': '3. Keperluan untuk memampatkan pakej',
    '课程简介不超过30个字': 'Pengenalan kursus hendaklah tidak melebihi 30 patah perkataan',
    '请求规则默认设置': 'Minta tetapan lalai peraturan',
    '条数据同步失败': 'Penyegerakan data gagal',
    '导航菜单': 'Menu navigasi',
    '数据正在导入中，请不要离开当前页面': 'Data sedang diimport, sila jangan tinggalkan halaman semasa',
    '不需要统计的商户': 'Peniaga yang tidak memerlukan statistik',
    '分账状态修改失败': 'Gagal mengubah suai status lejar',
    '生日：': 'Hari Lahir:',
    '结束日期': 'tarikh tamat',
    '亲属关系：': 'persaudaraan:',
    '手机号': 'Nombor telefon',
    '请求规则列表': 'Minta senarai peraturan',
    '仅支持jpg、jpeg、gif、png件的上传,请重新选择': 'Hanya menyokong muat naik fail jpg, jpeg, gif dan png, sila pilih sekali lagi.',
    '二次识别活体阈值不能为0': 'Ambang untuk pengecaman sekunder objek hidup tidak boleh 0',
    '下载人脸照片匹配表': 'Muat turun jadual padanan foto muka',
    '获取班级列表失败请刷新重试': 'Gagal mendapatkan senarai kelas, sila muat semula dan cuba lagi',
    '开': 'terbuka',
    '支付宝代扣': 'Penahanan Alipay',
    '收费项目信息不全，请先补充完整': 'Maklumat mengenai pengecasan item tidak lengkap, sila lengkapkan dahulu',
    '到期时间': 'Masa tamat tempoh',
    '人脸照片采集说明.docx': 'Arahan pengumpulan foto muka.docx',
    '收起': 'dekat',
    '保存': 'jimat',
    '截止时间：': 'Tarikh akhir:',
    '职工': 'kakitangan',
    '正在上传': 'Memuat naik',
    '创建人': 'Pencipta',
    '请等待匹配表文件上传完成，再进行该切换': 'Sila tunggu sehingga fail jadual yang sepadan dimuat naik sebelum melakukan suis ini.',
    '●干净纯色的照片背景为佳，推荐使用纯白色背景。(近肤色的背景除外)': '●Latar belakang foto berwarna bersih dan pepejal diutamakan dan latar belakang putih tulen disyorkan. (Kecuali latar belakang berwarna kulit)',
    '新密码': 'Kata Laluan Baharu',
    '周五': 'Jumaat',
    '学生姓名*': 'Nama pelajar*',
    '请填写门禁规则的结束日期或设置为永久生效': 'Sila isi tarikh tamat peraturan kawalan akses atau tetapkan ia berkuat kuasa secara kekal',
    '请输入最小识别阈值': 'Sila masukkan ambang pengecaman minimum',
    '程序错误，请稍后再试': 'Ralat program, sila cuba lagi kemudian',
    '周二': 'Selasa',
    '上传人脸照片匹配表': 'Muat naik jadual padanan foto muka',
    '优惠券链接': 'Pautan kupon',
    '支付时间': 'masa pembayaran',
    '4、在人脸照片匹配表填写“照片名称”后,上传到后台。': '4. Selepas mengisi "nama foto" dalam jadual padanan foto wajah, muat naik ke bahagian belakang.',
    '关闭其他': 'Tutup yang lain',
    '商户名称：': 'Nama peniaga:',
    '按商户统计': 'Statistik oleh peniaga',
    '不额外放行请假用户': 'Tiada keluaran tambahan akan diberikan kepada pengguna yang meminta cuti',
    '手机号码': 'nombor telefon',
    '更新资料': 'Kemas kini maklumat',
    '添加门禁动作': 'Tambah tindakan kawalan akses',
    '商户号：': 'Nombor peniaga:',
    '录入结果': 'Keputusan penyertaan',
    '已录入': 'Sudah masuk',
    '重置': 'set semula',
    '待分账': 'Untuk dibahagikan',
    '若为“必交”则默认勾选，且不可取消勾选，家长必须支付此项；若为“选交”，则家长可自由勾选并支付。最多可添加10个收费项目': 'Jika ia "Diperlukan", ia ditandakan secara lalai dan tidak boleh dinyahtandai. Ibu bapa mesti membayar item ini jika ia "Pilihan", ibu bapa boleh menyemak dan membayar secara percuma. Sehingga 10 item pengecasan boleh ditambah',
    '单选': 'Pilihan tunggal',
    '权限': 'kebenaran',
    '条': 'jalur',
    '退卡(次)': 'Bayaran balik kad(kali)',
    '人脸照片匹配表(家长)': 'Jadual padanan foto muka (ibu bapa)',
    '路径': 'laluan',
    '请输入课程名称': 'Sila masukkan nama kursus',
    '提示': 'petunjuk',
    '幼儿园刷卡机：160及其以上版本，低版本的请先升级': 'Mesin leret kad tadika: versi 160 dan ke atas, sila tingkatkan dahulu jika anda mempunyai versi yang lebih rendah.',
    '当前所属商户': 'Peniaga semasa',
    '+添加模板': '+Tambah templat',
    '退款(元)': 'Bayaran balik (yuan)',
    '请刷新重试': 'Sila muat semula dan cuba lagi',
    '请选择学生性别': 'Sila pilih jantina pelajar',
    '必交': 'Mesti bayar',
    '监听': 'pantau',
    '人脸照片匹配表(学生)': 'Jadual padanan foto muka (pelajar)',
    '周四': 'Khamis',
    '请填写门禁动作': 'Sila isikan tindakan kawalan akses',
    '请选择考试类型': 'Sila pilih jenis peperiksaan',
    '现金收支结余(元)': 'Baki penerimaan dan pembayaran tunai (yuan)',
    '就餐状态': 'Status makan',
    '选择学校': 'Pilih sekolah',
    '保密': 'Sulit',
    '地点': 'tempat',
    '已激活': 'Diaktifkan',
    '支付': 'bayar',
    '进出设置': 'Masuk dan keluar dari tetapan',
    '抓拍照片': 'Tangkap gambar',
    '默认允许所有人进出': 'Semua orang dibenarkan masuk dan keluar secara lalai',
    '学生标识：': 'ID Pelajar:',
    '家长手机号': 'Nombor telefon bimbit ibu bapa',
    '展示': 'pameran',
    '未添加收费项目，请先添加后提交': 'Tiada item pengecasan telah ditambahkan, sila tambahkannya dahulu dan kemudian serahkan.',
    '现金支出统计': 'Statistik pengeluaran tunai',
    '正在下载': 'Memuat turun',
    '获取编辑的内容失败': 'Gagal mendapatkan kandungan yang diedit',
    '默认禁止所有人进出': 'Semua orang dilarang masuk secara lalai',
    '全部状态': 'Semua status',
    '已录': 'Sudah dirakam',
    '请假用户将允许在设置的时段内被放行': 'Pengguna yang meminta cuti akan dibenarkan dilepaskan dalam tempoh masa yang ditetapkan',
    '选交': 'Pilih',
    '录入成功': 'Penyertaan berjaya',
    '学校人数': 'Penduduk sekolah',
    '永久生效': 'Berkesan secara kekal',
    '输入照片名称、职工姓名': 'Masukkan nama foto dan nama pekerja',
    '添加考试失败, 请重试': 'Gagal menambah peperiksaan, sila cuba lagi',
    '请输入后台地址': 'Sila masukkan alamat bahagian belakang',
    '今日已发起过催交提醒，请明天再执行催交操作': 'Peringatan mempercepatkan telah dimulakan hari ini Sila laksanakan operasi mempercepatkan lagi esok.',
    '收费项目': 'Mengecas barang',
    '账户管理': 'Pengurusan akaun',
    '人员去重': 'Penyahtinduan kakitangan',
    '请重试': 'Sila cuba lagi',
    '③填写表格时， 请勿修改“系统ID、手机号、职工姓名”。': '③Semasa mengisi borang, sila jangan ubah suai "ID sistem, nombor telefon bimbit, nama pekerja".',
    '交费规则：': 'Peraturan pembayaran:',
    '输入照片名称、孩子所属姓名': 'Masukkan nama foto dan nama kanak-kanak itu',
    '充值(元)': 'Caj semula (yuan)',
    '消费合计(次)': 'Jumlah penggunaan (kali)',
    '人脸库图片': 'Menghadapi gambar perpustakaan',
    '取消激活学校收费接口失败': 'Gagal menyahaktifkan antara muka pengecasan sekolah',
    '访客': 'pelawat',
    '配置': 'Konfigurasi',
    '建议尺寸：750*319，不超过1M，格式：jpg、jpeg、gif、png': 'Saiz yang disyorkan: 750*319, tidak lebih daripada 1M, format: jpg, jpeg, gif, png',
    '该学校暂无识别记录！': 'Pada masa ini tiada rekod pengenalan untuk sekolah ini!',
    '数据加载中': 'Pemuatan data',
    '当前表格有': 'Jadual semasa mempunyai',
    '实验室': 'makmal',
    '校园缴费v1.2_后台_获取分账默认设置接口失败': 'Pembayaran kampus v1.2_backend_failed untuk mendapatkan antara muka tetapan lalai akaun cawangan',
    '②请勿修改表格模板格式。': '② Tolong jangan ubah suai format templat borang.',
    '产品运营': 'Operasi produk',
    '默认': 'lalai',
    '请输入最大识别阈值': 'Sila masukkan ambang pengecaman maksimum',
    '正在提交...': 'Menyerahkan...',
    '百度': 'Baidu',
    '测试': 'ujian',
    '考试名': 'Nama peperiksaan',
    '请等待压缩包文件上传完成，再进行该切换': 'Sila tunggu sehingga fail pakej termampat dimuat naik sebelum melakukan suis ini.',
    '全屏': 'skrin penuh',
    '规则开始日期': 'Tarikh mula peraturan',
    '恢复激活年': 'Kembali ke tahun pengaktifan',
    '登记信息': 'Maklumat pendaftaran',
    '二次识别阈值': 'ambang pengiktirafan sekunder',
    '不超过15个字': 'Tidak lebih daripada 15 patah perkataan',
    '角色管理': 'pengurusan peranan',
    '账单已开启收费': 'Bill telah didakwa',
    '成绩管理': 'Pengurusan skor',
    '通知模板': 'templat pemberitahuan',
    '【家长】仅针对带人脸识别功能的设备有效，其他设备可以不用设置': '[Ibu bapa] hanya sah untuk peranti dengan fungsi pengecaman muka Peranti lain tidak perlu menetapkannya.',
    '月': 'bulan',
    '批量录入人脸': 'Masukkan wajah secara berkelompok',
    '学校商户配置': 'Konfigurasi peniaga sekolah',

    '职工管理(新版)': 'Pengurusan Pekerja (Versi Baru)',
    '学生管理（新版）': 'Pengurusan Pelajar (Versi Baru)',
    '模拟刷卡': 'Simulasi Kad',
    '支付宝模拟登陆': 'Log Masuk Simulasikan Alipay',
    '微信模拟登录': 'Log Masuk Simulasikan WeChat',
    '回收站': 'Stesen Kitar Semula',
    '通知公告': 'Notis Pengumuman',
    '查看': 'Lihat',
    '班级排序': 'Susunan Kelas',
    '作业': 'Tugasan',
    '作业列表': 'Senarai Tugasan',
    '发布作业': 'Terbitkan Tugasan',
    '通知发布': 'Terbitkan Notis',
    '接收记录': 'Rekod Penerimaan',
    '异常列表': 'Senarai Pengecualian',
    '关键字列表': 'Senarai Kata Kunci',
    '萌萌圈查看': 'Lihat Bulatan Meng Meng',
    '萌萌圈待审核列表': 'Senarai Menunggu Pengesahan Bulatan Meng Meng',
    '萌萌圈评论待审核列表': 'Senarai Ulasan Menunggu Pengesahan Bulatan Meng Meng',
    '显示范围设置': 'Tetapan Julat Paparan',
    '视频查看': 'Lihat Video',
    '学生自主审核列表': 'Senarai Semak Sendiri Pelajar',
    '成长记录': 'Rekod Pertumbuhan',
    '我的学校': 'Sekolah Saya',
    '学校简介': 'Pengenalan Sekolah',
    '学校新闻': 'Berita Sekolah',
    '新闻列表': 'Senarai Berita',
    '新闻发布': 'Terbitkan Berita',
    '编辑学校简介': 'Edit Pengenalan Sekolah',
    '标记地理位置': 'Tandakan Lokasi Geografi',
    '考勤管理': 'Pengurusan Kehadiran',
    '门禁规则（旧）': 'Peraturan Pintu Masuk (Lama)',
    '考勤明细重算': 'Pengiraan Semula Butiran Kehadiran',
    '考勤率': 'Kadar Kehadiran',
    '考勤管理(新版)': 'Pengurusan Kehadiran (Versi Baru)',
    '考勤管理(旧版)': 'Pengurusan Kehadiran (Versi Lama)',
    '大屏轮播管理': 'Pengurusan Gelongsor Skrin Besar',
    '考勤标签管理': 'Pengurusan Tanda Kehadiran',
    '考勤汇总': 'Ringkasan Kehadiran',
    '考勤记录': 'Rekod Kehadiran',
    '签到二维码': 'Kod QR Daftar Masuk',
    '考勤规则管理': 'Pengurusan Peraturan Kehadiran',
    '考勤规则管理(新版)': 'Pengurusan Peraturan Kehadiran (Versi Baru)',
    '考勤规则管理(旧版)': 'Pengurusan Peraturan Kehadiran (Versi Lama)',
    '考勤明细': 'Butiran Kehadiran',
    '考勤明细(新版)': 'Butiran Kehadiran (Versi Baru)',
    '考勤明细(旧版)': 'Butiran Kehadiran (Versi Lama)',
    '人脸识别功能管理': 'Pengurusan Ciri Pengenalan Wajah',
    '人脸库管理': 'Pengurusan Perpustakaan Wajah',
    '识别记录（仅考勤）': 'Rekod Pengenalan (Hanya Kehadiran)',
    '服务管理(新版)': 'Pengurusan Perkhidmatan (Versi Baru)',
    '识别记录(新版)': 'Rekod Pengenalan (Versi Baru)',
    '推送限制': 'Had Dorongan',
    '校园缴费': 'Bayaran Kampus',
    '职工消费统计': 'Statistik Penggunaan Kakitangan',
    '系统设置': 'Tetapan Sistem',
    '审核': 'Pengauditan',
    '毕业管理': 'Pengurusan Lulusan',
    '图片加载失败': 'Gagal Muat Gambar',
    '验证码不正确，请重新刷新': 'Kod Pengesanan Tidak Benar, Sila Cek Semula',
    '账号密码错误，还剩余4次输入机会': 'Salah Nombor Pengguna/Pasword, Masih Ada 4 Kesempatan',
    '账号密码错误，还剩余3次输入机会': 'Salah Nombor Pengguna/Pasword, Masih Ada 3 Kesempatan',
    '账号密码错误，还剩余2次输入机会': 'Salah Nombor Pengguna/Pasword, Masih Ada 2 Kesempatan',
    '账号密码错误，还剩余1次输入机会': 'Salah Nombor Pengguna/Pasword, Hanya Ada 1 Kesempatan',
    '请先输入用户名': 'Sila Masukkan Nama Pengguna Terlebih Dahulu',
    '请先输入密码': 'Sila Masukkan Kata Laluan Terlebih Dahulu',
    '请输入验证码': 'Sila Masukkan Kod Pengesanan',
    '验证码': 'Kod Pengesanan',
    '当前账号的密码是弱密码，请联系运营人员修改': 'Kata Laluan Akun Segerak Lemah, Sila Hubungi Pihak Operasi Untuk Mengubahnya',
    '验证码不存在': 'Kod Pengesanan Tidak Wujud',
    '编辑考试': 'Kemaskini Ujian',
    '学生成绩需要通过表格形式导入，点击此处': 'Perlu Memasukkan Nilai Pelajar Melalui Borang, Klik Di Sini',
    '导入成绩': 'Muat Naik Nilai',
    '学生录入情况': 'Status Pemasukan Pelajar',
    '成绩汇总': 'Ringkasan Nilai',
    '导入方式:': 'Cara Muat Naik:',
    '按学生id': 'Berdasarkan ID Pelajar',
    '按学生姓名': 'Berdasarkan Nama Pelajar',
    '导入成绩需要按照模板格式填入数据，否则将导入失败，点击': 'Perlu Memasukkan Nilai Menurut Format Templat, Jika Tidak, Muat Naik Akan Gagal, Klik',
    '导入名单:': 'Senarai Muat Naik:',
    '导入': 'Muat Naik',
    '表格导入成功': 'Berjaya Muat Naik Borang',
    '人，导入失败': 'Orang, Muat Naik Gagal',
    '下载导入失败名单': 'Muat Turun Senarai Muat Naik Gagal',
    '填写须知:': 'Petunjuk:',
    '1、请按照表格模板中的名单进行成绩的录入，支持调整表格中学生的顺序，系统将通过姓名、年级、班级3个字段进行学生成绩的匹配': '1, Sila Masukkan Nilai Menurut Senarai Dalam Templat Borang, Sokong Menyesuaikan Urutan Pelajar Dalam Borang, Sistem Mencari Nilai Pelajar Melalui Tiga Bidang: Nama, Tingkat, Kelas',
    '2、若表格中同个班级存在相同姓名的学生，则系统将随机匹配该学生成绩，请在表格导入后于管理平台上自行修改相同姓名的学生成绩': '2, Jika Ada Pelajar Dengan Nama Yang Sama Dalam Kelas Yang Sama Dalam Borang, Sistem Akan Mencocokkan Nilai Mereka Secara Acak, Sila Modifikasi Nilai Pelajar Dengan Nama Yang Sama Di Platform Pengurusan Selepas Muat Naik Borang',
    '3、按照下载的模板填入相应的数据，请勿修改字段的位置和删减字段': '3, Isi Maklumat Menurut Templat Yang Dimuat, Jangan Ubah Posisi Lapangan Dan Padam Lapangan Mana Pun',
    '4、是否缺考字段默认选择“否”。若选择\'是\', 则各科分数可不填': '4, Lapangan \'Tidak Hadir\' Default Set To \'Tidak\'. Jika Dipilih Sebagai \'Ya\', Skor Untuk Setiap Mata Pelajaran Boleh Dibiarkan Kosong',
    '5、分数格式有“数字”、“-”和“缺考”3种。“数字”即为该科的分值，“-”表示特殊情况不计该科成绩，“缺考”表示单科缺考': '5, Format Skor Termasuk \'Nombor\', \'-\' (kurang), dan \'Tidak Hadir\'. \'Nombor\' Adalah Skor Mata Pelajaran, \'-\' Menunjukkan Kesilapan Spesial Di mana Skor Mata Pelajaran Tidak Ditanggung, \'Tidak Hadir\' Berarti Absen Dari Satu Mata Pelajaran',
    '6、填入的分数不得超过该科最高分值': '6, Skor yang Dimasukkan Tidak Boleh Melebihi Skor Maksimum Mata Pelajaran',
    '7、可在表格最右侧增加备注字段': '7, Boleh Menambah Catatan di Sebelah Kiri Terakhir Borang',
    '（不可在原字段中间插入其他字段），导入时不录入数据库': '(Tidak Boleh Menambah Lapangan Lain Dalam Lapangan Asal), Tidak Rekod Dalam Pangkalan Data Semasa Muat Naik',
    '是否缺考': 'Apakah Tidak Hadir',
    '语文': 'Bahasa Cina',
    '数学': 'Matematik',
    '获取成绩导入班级失败, 请刷新重试': 'Gagal Muat Naik Nilai Kelas, Sila Cek Semula dan Coba Lagi',
    '数据库中该班级没有学生': 'Tiada Pelajar Dalam Kelas Ini Dalam Pangkalan Data',
    '成绩导入完成': 'Nilai Muat Naik Selesai',
    '成绩录入失败，请重新上传': 'Gagal Memasukkan Nilai, Sila Muat Naik Semula',
    '成绩录入失败了，请重新上传！': 'Gagal Memasukkan Nilai, Sila Muat Naik Semula!',
    '获取成绩详情失败, 请刷新重试': 'Gagal Mendapatkan Butiran Nilai, Sila Cek Semula dan Coba Lagi',
    '执行中...': 'Dalam Proses...',
    '模板下载中...': 'Mendownload Templat...',
    '模板下载成功': 'Berjaya Mendownload Templat',
    '没有导出失败的学生': 'Tiada Pelajar Gagal Dieksport',
    '表格上传中...': 'Memenyimpan Borang...',
    '请检查导入表格数据是否为空': 'Silakan Periksa Apakah Data Borang Muat Naik Kosong',
    '表格导入成功,请提交': 'Berjaya Muat Naik Borang, Sila Kemukakan',
    '表格数据处理失败,请刷新重试': 'Gagal Proses Data Borang, Sila Cek Semula dan Coba Lagi',
    '请勿修改模板表头': 'Jangan Ubah Judul Templat',
    '字段值、位置或删减，按模板重新导入！': 'Nilai Lapangan, Lokasi atau Penyingkiran, Muat Naik Semula Menurut Templat!',
    '请填写除模板示例外要导入的学生数据': 'Sila Isi Data Pelajar Selain Contoh Templat Yang Perlu Muat Naik',
    '请按模板填写第': 'Sila Isi Menurut Templat',
    '位学生的“是否缺考”信息': 'Butiran \'Apakah Tidak Hadir\' Bagi Pelajar Ke-',
    '位学生的': 'Bagi Pelajar Ke-',
    '第': 'Ke-',
    '成绩不能为负数，请重新填写': 'Skor Tidak Boleh Negatif, Sila Isi Semula',
    '位学生正确的': 'Skor Pelajar Ke-',
    '成绩格式': 'Format Skor',
    '分数超过该科最高分值': 'Skor Melebihi Skor Maksimum Mata Pelajaran',
    '分，请修改重新导入': 'Skor, Sila Kaji dan Muat Naik Semula',
    '信息': 'Butiran',
    '请勿删除或修改模板表头姓名字段等信息，请重新导入': 'Jangan Padam atau Ubah Maklumat Seperti Nama dalam Judul Templat, Sila Muat Naik Semula',
    '请勿删除或修改模板表头id,姓名字段等信息，请重新导入': 'Jangan Padam atau Ubah Maklumat Seperti id, Nama dalam Judul Templat, Sila Muat Naik Semula',
    '表格导入数据失败,请刷新重试': 'Gagal Muat Naik Data Borang, Sila Cek Semula dan Coba Lagi',
    '数据上传中...': 'Memenyimpan Data...',
    '请先选择文件上传表格': 'Sila Pilih Fail untuk Muat Naik Borang',
    '成绩导入': 'Muat Naik Nilai',
    '人，已录入': 'Orang, Sudah Dimasukkan',
    '人。': 'Orang.',
    '系统id': 'ID Sistem',
    '请先保存当前编辑项': 'Sila Simpan Edits Terkini Terlebih Dahulu',
    '编辑学生成绩失败, 请重新编辑': 'Gagal Kemaskini Nilai Pelajar, Sila Kemaskini Lagi',
    '保存成功!': 'Berjaya Disimpan!',
    '人，未录入': 'Orang, Belum Dimasukkan',
    '+附件上传': '+ Lampiran Muat Naik',
    '规则设置': 'Atur Aturan',
    '幼儿园刷卡机': 'Pembaca Kad Taman Kanak-Kanak',
    '3G车载设备': 'Peranti Pengangkutan 3G',
    '测温枪': 'Pistol Pengukur Suhu',
    '消费设备': 'Peranti Penggunaan',
    '访客设备': 'Peranti Pelawat',
    '中小学刷卡机': 'Pembaca Kad Sekolah Rendah dan Menengah',
    '闸门设备': 'Peranti Pintu Gerbang',
    '摄像头': 'Kamera',
    '大屏指纹机': 'Mesin Cap Jari Skrin Besar',
    '无障碍通道': 'Laluan Tanpa Halangan',
    '彩色小摆闸': 'Pintu Putar Kecil Berwarna',
    '4G车载设备': 'Peranti Pengangkutan 4G',
    '卧式消费机': 'Mesin Penggunaan Mendatar',
    '人脸识别摄像头': 'Kamera Pengenalan Wajah',
    '电子班牌': 'Papan Kelas Elektronik',
    '路由器设备': 'Peranti Penghala',
    '挂式消费机': 'Mesin Penggunaan Gantung',
    '人脸识别闸门': 'Pintu Gerbang Pengenalan Wajah',
    '触控一体机': 'Mesin Sentuh Sekeping',
    '报警主机': 'Host Penggera',
    '圆柱单目人脸识别机': 'Mesin Pengenalan Wajah Monokular Silinder',
    '接警主机': 'Host Penerima Panggilan Kecemasan',
    '人脸识别车载APP': 'APP Pengenalan Wajah Kenderaan',
    '食堂团餐设备': 'Peranti Makanan Berkumpulan Kantin',
    '推流盒子(Android)': 'Kotak Penstriman (Android)',
    '自助售货机': 'Mesin Jualan Sendiri',
    '公安人脸摄像头': 'Kamera Pengenalan Wajah Keselamatan Awam',
    '人脸识别消费盒子': 'Kotak Penggunaan Pengenalan Wajah',
    '推流盒子(Linux)': 'Kotak Penstriman (Linux)',
    '挂式消费机2代': 'Mesin Penggunaan Gantung Generasi Kedua',
    '消费盒子(Linux)': 'Kotak Penggunaan (Linux)',
    '人脸识别闸门A': 'Pintu Gerbang Pengenalan Wajah Jenis A',
    '宿舍人脸识别闸门': 'Pintu Gerbang Pengenalan Wajah Asrama',
    '批量录入详情': 'Butiran Pemasukan Bulatan',
    '_学生_批量录入结果_': '_Hasil Pemasukan Bulatan Pelajar_',
    '_职工_批量录入结果_': '_Hasil Pemasukan Bulatan Pekerja_',
    '_家长_批量录入结果_': '_Hasil Pemasukan Bulatan Ibu Bapa_',
    ',请重新导出': ',Sila Eksport Semula',
    '清除': 'padam',
    '1、当前支持的设备': '1. Peranti yang disokong pada masa ini',
    '2、其他设备': '2. Peranti lain',
    '"学生、职工、家长"中的3个筛选项，请至少选填1项': 'Sila pilih sekurang-kurangnya satu daripada tiga pilihan: "Pelajar", "Staf", atau "Ibu bapa"',
    '职位管理': 'Pengurusan jawatan',
    '系统管理员': 'Pengurus Sistem',
    '中文': 'Cina',
    'English': 'Inggeris',
    'Malaysia': 'Malaysia',
    '萌萌圈评论审核列表': 'Senarai Pengesanan Ulasan Momo Circle',
    '学校自主审核列表': 'Senarai audit kendiri sekolah',
    '单元': 'unit',
    '缺考': 'Tidak Hadir',
    '分数格式错误': 'Format Skor Tidak Sah',
    '示例（可删除）': 'Contoh (Boleh Dibuang)',
    '备注': 'Catatan',
    '健康管理': 'Pengurusan Kesihatan',
    '健康日报': 'Kesihatan Harian',
    '选择时段': 'Pilih tempoh masa',
    '角色类型': 'Jenis peranan',
    '选择状态': 'Pilih status',
    '正常': 'biasa',
    '异常': 'tidak normal',
    '职位': 'kedudukan',
    '测温时段': 'Tempoh pengukuran suhu',
    '温度': 'suhu',
    '获取老师体温列表失败, 请刷新重试': 'Gagal mendapatkan senarai suhu guru, sila muat semula dan cuba lagi',
    '获取学生体温列表失败, 请刷新重试': 'Gagal mendapatkan senarai suhu pelajar, sila muat semula dan cuba lagi',
    '获取时段列表失败, 请刷新重试': 'Gagal mendapatkan senarai tempoh masa, sila muat semula dan cuba lagi',
    ', 请刷新重试': ', sila muat semula dan cuba lagi',
    '③填写表格时， 请勿修改“系统ID、手机主号、年级、班级、学生姓名”。': 'Apabila mengisi borang, jangan ubah "ID sistem, nombor telefon bimbit utama, gred, kelas, nama pelajar".',
    '④对于已录入照片的学生，重新录入的话，新照片将会覆盖旧照片。': 'Untuk pelajar yang telah memasukkan gambar, jika dimasukkan semula, gambar baru akan menggantikan gambar lama.',
    '选择的用户类型或上传的人脸照片匹配表有误': 'Pilih jenis pengguna atau muat naik jadual perlawanan foto wajah yang salah',
    ',请刷新后重试': ',Sila muat semula dan cuba lagi',
    '未填写照片名称，默认不进行任何处理': 'Jika nama foto tidak diisi, tiada pemprosesan akan dilakukan secara lalai',
    '用户人脸已经存在，请先删除再上传': 'Wajah pengguna sudah wujud, sila padamkannya sebelum memuat naiknya',
    '使用帮助': 'Tolong',
    '帮助详情': 'Butiran bantuan',
    '英语': 'Bahasa Inggeris',
    '物理': 'fizik',
    '化学': 'kimia',
    '生物': 'biologi',
    '地理': 'Geografi',
    '政治': 'Politik',
    '历史': 'Sejarah',
    '体育': 'Sukan',
    '音乐': 'Muzik',
    '美术': 'Seni',
    '文综': 'Kompleks',
    '信息技术': 'Teknologi Maklumat',
    '文科综合': 'Integrasi Seni Liberal',
    '理科综合': 'Sains Integrasi',
    '职工ID': 'ID Pekerja',
    '已经有任务正在进行': 'Terdapat tugas yang sedang dijalankan.',
    '当前表格为空': 'Jadual semasa kosong',
    '下载人脸照片采集说明地址': 'https://xbullyun.x-bull.com/app_agreement/Panduan%20Pengumpulan%20Foto%20Muka.docx',
    '请求错误': 'Ralat permintaan',
    '服务器内部错误，请联系管理员': 'Ralat dalaman pelayan, hubungi pentadbir',
    '登录已过期， 请重新登陆': 'Login tamat tempoh, sila log masuk semula',
    '请求失败,请刷新重试': 'Permintaan gagal, sila cuba semula',
    '请勿重复设置，门禁规则“': 'Jangan ulangi tetapan, peraturan kawalan akses "',
    '”已经设置过': '" telah ditetapkan',
    '的家长': ' Ibu bapa',
    '人脸照片过小，请重新用高像素相机或靠近拍照上传': 'Foto muka terlalu kecil. Sila muat naik semula dengan kamera piksel tinggi atau ambil foto lebih dekat',
    '人脸读取失败，请确定图片可以正常访问': 'Bacaan muka gagal, sila pastikan imej boleh diakses seperti biasa',
    '图片内人脸数量过多，识别失误，请重新拍照上传': 'Terdapat terlalu banyak wajah dalam gambar, dan pengecaman gagal. Sila ambil foto baharu dan muat naiknya',
    '图片检测不合格，请重新拍照上传': 'Pengesanan imej gagal, sila ambil foto baharu dan muat naiknya',
    '眼睛或眉毛被遮挡，请重新拍照上传': 'Mata atau kening disekat, sila ambil foto baharu dan muat naiknya',
    '鼻子被遮挡，请重新拍照上传': 'Hidung tersumbat, sila ambil gambar baharu dan muat naik',
    '嘴巴被遮挡，请重新拍照上传': 'Mulut tersumbat, sila ambil gambar baharu dan muat naik',
    '左脸颊被遮挡，请重新拍照上传': 'Pipi kiri tersumbat, sila ambil gambar baharu dan muat naik',
    '右脸颊被遮挡，请重新拍照上传': 'Pipi kanan disekat, sila ambil foto baharu dan muat naik',
    '光线过暗，请重新拍照上传': 'Cahaya terlalu gelap, sila ambil foto baharu dan muat naiknya',
    '光线过亮，请重新拍照上传': 'Cahaya terlalu terang, sila ambil foto baharu dan muat naiknya',
    '头部过于低，请重新拍照上传': 'Kepala terlalu rendah, sila ambil foto baharu dan muat naik',
    '头部过于昂，请重新拍照上传': 'Kepala terlalu tinggi, sila ambil gambar baharu dan muat naik',
    '头部过于左倾，请重新拍照上传': 'Kepala terlalu condong ke kiri, sila ambil foto baharu dan muat naiknya',
    '头部过于右倾，请重新拍照上传': 'Kepala terlalu condong ke kanan, sila ambil foto baharu dan muat naiknya',
    '头部过于左偏，请重新拍照上传': 'Kepala terlalu condong ke kiri, sila ambil foto baharu dan muat naiknya',
    '头部过于右偏，请重新拍照上传': 'Kepala terlalu condong ke kanan, sila ambil foto baharu dan muat naiknya',
    '人脸过于模糊，请重新拍照上传': 'Wajah terlalu kabur, sila ambil foto baharu dan muat naik',
    '人脸轮廓不够完整，请重新拍照上传': 'Garis muka tidak lengkap, sila ambil foto baharu dan muat naiknya',
    '活体检测未通过，请重新拍照上传': 'Ujian keceriaan gagal. Sila ambil foto baharu dan muat naiknya',
    '该人脸已经存在，请不要重复上传': 'Wajah ini sudah wujud, tolong jangan muat naik lagi',
    '找不到上传记录': 'Rekod muat naik tidak ditemui',
    '人脸校验token未找到，请先校验人脸': 'Token pengesahan muka tidak ditemui, sila sahkan muka dahulu',
};
